import React, { useState, useEffect, memo, useRef, useCallback } from 'react';
import useDialog from '../../HooksPerson/useDialog';
import mapboxgl from 'mapbox-gl';
import handleNetWatch from '../helpers/handleNetWatch';
import GenerarPass from '../../helpers/GenerarPass';
import copy from "copy-to-clipboard";  
import UploadElementYounet from './UploadElementYounet';
import { 
    Avatar,
    Card,
    CardContent,
    Chip,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    LinearProgress,
    MenuItem,
    Paper,
    Switch,
    TextField,
    Tooltip,
    Divider,
   } from '@material-ui/core';
import { 
       Block as BlockIcon,
       CheckCircle as CheckCircleIcon,
       Dns as DnsIcon,
       EmojiObjects as EmojiObjectsIcon,
       Event as EventIcon,
       GpsFixed as GpsFixedIcon,
       MonetizationOn as MonetizationOnIcon,
       Place as PlaceIcon,
       Router as RouterIcon,
       Speed as SpeedIcon,
       Whatshot as WhatshotIcon,
       AddCircle as AddCircleIcon,
       PhotoCamera as PhotoIcon,
   } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import swal from 'sweetalert';
import PdfInstalacionFibra from '../PdfInstalacionFibra';
import Swal from 'sweetalert2';
import { v4 as uuidv4 } from 'uuid';
import { 
    Button as ButtonAntd,
    Checkbox as CheckboxAntd,
    Modal as ModalAntd,
    Popconfirm, 
    Switch as SwitchAntd,
    Tooltip as TooltipAntd, 
} from 'antd';
import { 
    ApiOutlined as ApiOutlinedIcon,
    AreaChartOutlined,
    LockOutlined, 
    ClusterOutlined as ClusterOutlinedIcon,
    ChromeFilled as ChromeOutlinedIcon,
    CopyOutlined as ContentCopyIcon, 
    DeleteOutlined as DeleteOutlinedIcon,
    EyeOutlined as EyeOutlinedIcon,
    EyeInvisibleOutlined as EyeInvisibleOutlinedIcon,
    FilePdfOutlined as FilePdfOutlinedIcon,
    LoadingOutlined as LoadingOutlinedIcon,
    NodeIndexOutlined,
    PoweroffOutlined as PoweroffOutlinedIcon,
    RedoOutlined as RedoOutlinedIcon, 
    ReloadOutlined as ReloadOutlinedIcon,
    SaveOutlined as SaveOutlinedIcon,
    SecurityScanOutlined as SecurityScanOutlinedIcon,
    SettingOutlined as SettingOutlinedIcon,
    SyncOutlined as SyncOutlinedIcon,
    TeamOutlined as TeamOutlinedIcon,
    UngroupOutlined,
    WifiOutlined as WifiOutlinedIcon
   } from '@ant-design/icons';
import ConvertArrToJson from '../helpers/ConvertArrToJson';
import capitalize from '../../Elementos/Capitalize';
import handleShowMacOnuInformation from '../helpers/ShowMacOnu';
import isValidCoordinates from '../helpers/isValidCoordinates';

const getCuentas = [ 'CiberCafe', 'Corporativo', 'Residencial', 'Otros' ];

const onlyMeses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

const ElementServiciosFibra = memo((props)=>{
    const { 
            authTokens, 
            classes, 
            data,
            dataCliente, 
            enqueueSnackbar,
            getAddClientMikrotik, 
            getArrIdForMikrotik, 
            // getEquiposAll,
            getPlanes,
            getTecnicos,
            handleBorrarServicio, 
            handleBorrarServicioMongo, 
            handlePostServicio, 
            handlePutServicio, 
            index, 
            zonaSelected, 
    } = props;
    const [ statusServicioAdd, setStatusServicioAdd ] = useState(true);
    const [ DatosD, setDatosD] = useState({
        Instalacion:'',
        AddressIp:'',
        Plan:'',
        ValorInstalacion:'',
        idForMikrotik:'',
        ZonaService:zonaSelected.Zona,
        CorteAutomatico:true,
        TipoPagoBoolean:true,
        StatusIns:false,
        Red:'',
        Mascara:'',
        Status:'',
        UserMk:'telecomadmin',
        PassMk:'admintelecom',
        IVA:false,
        SN:'',
        DiaNotificacion:1,
        DiasCorte:4,
        MacOnu:'',
        MacRouter:'',
        TipoCuenta:'',
        TiempoPermanencia:'',
        isTelnet:false,
        isFree:false
    });
    const [ isSaving, setSaving ] = useState(false);
    const [ isNotificacion, setNotificacion ] = useState(false);
    const [ Planes, setPlanes ] = useState([]);
    const [ isReadyPdf, setReadyPdf ] = useState(false);
    const [ onlyRouters, setOnlyRouters ] = useState([]);
    const [ onlyOnts, setOnlyOnts ] = useState([]);
    const [ macsRouters, setMacsRouters ] = useState([]);
    const [ macsOntArr, setMacsOntArr ] = useState([]);
    const [ snOntArr, setSnOntArr ] = useState([]);
    const [ snRouterArr, setSnRouterArr ] = useState([]);
    //const [ getInfoSync, setInfoSync ] = useState({});
    const [ getArrIpService, setArrIpService ] = useState([]);
    const [ getArrIpServiceIptv, setArrIpServiceIptv ] = useState([]);
    const [ openPhoto, setOpenPhoto ] = useState(false);
    const [ getArrPhotos, setArrPhotos ] = useState([]);
    const [ isOnuBridge, setOnuBridge ] = useState(true);
    const [ getInfoBackup, setInfoBackup ] = useState({});
    const [ isSearchingOnu, setSearchingOnu ] = useState(false);
    const [ isSearchingPPOE, setSearchingPPOE ] = useState(false);
    const [ isNewService, setNewService ] = useState(false);
    const [ getSearchingOptic, setSearchingOptic ] = useState(false);
    const [ getShowWifiInfo, setShowWifiInfo ] = useState(false);
    const [ getShowWifiAssociate, setShowWifiAssociate ] = useState(false);
    const [ openConfWifi , handleOpenConfWifi, handleCloseConfWifi ] = useDialog();
    const [ getNameWifi, setNameWifi ] = useState('');
    const [ getPassWifi, setPassWifi ] = useState('');
    const [ isOnWifi, setOnWifi ] = useState(false);
    const [ isOffWifi, setOffWifi ] = useState(false);
    const [ isHiddenWifi, setHiddenWifi ] = useState(false);
    const [ isNoHiddenWifi, setNoHiddenWifi ] = useState(false);
    const [ isChangeName, setNameChange ] = useState(false);
    const [ isChangePass, setPassChange ] = useState(false);
    const [ getAvance, setAvance ] = useState(0);
    const [ isRebootOnt, setRebootOnt ] = useState(false);
    const [ is5G, set5G ] = useState(false);
    const [ getCoord, setCoord ] = useState('-2.201567808901885, -79.93395424851998');
    const [ isSearchingPingOnu, setSearchingPingOnu ] = useState(false);
    const [ isCreateInstalacion, setCreateInstalacion ] = useState(true);
    const [ isCreateInvoice, setCreateInvoice ] = useState(true);
    const [ isSearchingMacOnu, setSearchingMacOnu ] = useState(false);
    const [ isUnify, setUnify ] = useState(false);
    const [ isServActive, setServActive ] = useState(false);
    const [ isOttActive, setOttActive ] = useState(false);
    const [ isOfflineServ, setOfflineServ ] = useState(false);
    const [ isOttServ, setOttServ ] = useState(false);
    const [ stock, setStock ] = useState([]);
    const [ getArrIp, setArrIp] = useState([]);
    const [ getArrIpIptv, setArrIpIptv] = useState([]);
    const [ isIpsCharged, setIpsCharged] = useState(false);
    const [ getEquiposAll, setEquiposAll ] = useState([]);
    const mapDiv = useRef();
    const mapa = useRef();

    useEffect(()=>{
        if(data.isNew){ 
            (async ()=>{
                if (zonaSelected.isIptv) {
                    fetch('/api/getIpsQueueTree', {
                        method: 'POST',
                        body: JSON.stringify({ InfoZona: zonaSelected }),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                        .then(response => response.json())
                        .then((result) => {
                            let arrComp = [];
                            for (const x in zonaSelected.SubnetIptv) {
                                let data = zonaSelected.SubnetIptv[x];
                                let rangeZone = data.Red.split('.');
                                const arr4 = [];
                                const arrComplete4 = [];
                                for (const x in result) {
                                    for (const y in result[x]) {
                                        if (result[x][y].field === 'address') {
                                            let val = result[x][y].value.split('.');
                                            let range = `${val[0].toString()}.${val[1].toString()}.${val[2].toString()}.0`
                                            if (data.Red.toString() === range.toString()) arr4.push(result[x][y].value);
                                        }
                                    };
                                };
                                for (let i = 2; i < 255; i++) {
                                    let number = `${rangeZone[0].toString()}.${rangeZone[1].toString()}.${rangeZone[2].toString()}.${i}`;
                                    if (arr4.includes(number)) {
                                        const objeto = {};
                                        for (const x in result) {
                                            for (const y in result[x]) {
                                                if (result[x][y].field === 'address') {
                                                    if (result[x][y].value === number) objeto.idForMikrotik = result[x][6] ? result[x][6].value : null
                                                }
                                            };
                                        };
                                        objeto.IP = number;
                                        objeto.Status = 'NO DISPONIBLE';
                                        arrComplete4.push(objeto);
                                    } else {
                                        const objeto = {};
                                        objeto.Status = 'DISPONIBLE';
                                        objeto.IP = number;
                                        arrComplete4.push(objeto);
                                    }
                                }
                                arrComp = arrComp.concat(arrComplete4);
                            };
                            setArrIpIptv(arrComp);
                        });
                }
                
                if(zonaSelected.sysintercom){
                    fetch('/api/getIpsSimpleQueue',{
                        method:'POST',
                        body: JSON.stringify({InfoZona:zonaSelected}),
                        headers:{'Content-Type': 'application/json'}
                    }) 
                    .then(response=> response.json())
                    .then((result) =>{
                        let arrComp = [];
                        for(const x in zonaSelected.Subnet){
                            let data = zonaSelected.Subnet[x];
                            let rangeZone = data.Red.split('.');
                            const arr4 = [];
                            const arrComplete4 = [];
                            for(const x in result){
                                for(const y in result[x]){
                                    if(result[x][y].field === 'target'){ 
                                        if(result[x][y].value.split('/').length === 2){
                                            let val_0 = result[x][y].value.split('/')[0].toString();
                                            let val = val_0.split('.');
                                            let range = `${val[0].toString()}.${val[1].toString()}.${val[2]?.toString()}.0`
                                            if(data.Red.toString() === range.toString()) arr4.push(val_0);
                                        }
                                    }
                                };
                            };
                            for(let i = 2; i < 255; i++ ){
                                let number = `${rangeZone[0].toString()}.${rangeZone[1].toString()}.${rangeZone[2].toString()}.${i}`;
                                if(arr4.includes(number)){
                                    const objeto = {};
                                    for(const x in result){
                                        for(const y in result[x]){
                                            if(result[x][y].field === 'target'){ 
                                                if(result[x][y].value.split('/').length === 2){
                                                    let val_0 = result[x][y].value.split('/')[0].toString();
                                                    if(val_0 === number) {
                                                        objeto.idForMikrotik = result[x][1].value ;
                                                        objeto.idFromMikrotikSimple = result[x][0].value ;
                                                    }
                                                }
    
                                            }
                                        };
                                    };
                                    objeto.Status = 'NO DISPONIBLE';
                                    objeto.IP = number;
                                    arrComplete4.push(objeto);                                           
                                }else{
                                    const objeto = {};
                                    objeto.Status = 'DISPONIBLE';
                                    objeto.IP = number;
                                    arrComplete4.push(objeto);
                                }
                            }
                            arrComp = arrComp.concat(arrComplete4);
                        };
                        fetch('/api/getIpsQueueTree',{
                            method:'POST',
                            body: JSON.stringify({InfoZona:zonaSelected}),
                            headers:{
                                'Content-Type': 'application/json'
                            }
                        }) 
                        .then(response=> response.json())
                        .then(async (result2) =>{    
                            const jsonNew = await ConvertArrToJson(result2);
                            let arrComp2 = [];
                            for(const x in zonaSelected.Subnet){
                                let data = zonaSelected.Subnet[x];
                                let rangeZone = data.Red.split('.');
                                const arrComplete8 = [];
                                
                                const arr8 = jsonNew.filter(el=>{
                                    let val = el.address?.split('.');
                                    let range = `${val[0].toString()}.${val[1].toString()}.${val[2]?.toString()}.0`;
                                    if(data.Red.toString() === range.toString()) return true;
                                    else  return false;
                                }).map(el=>el.address).splice(1);
    
                                for(let i = 2; i < 255; i++ ){
                                    let number = `${rangeZone[0].toString()}.${rangeZone[1].toString()}.${rangeZone[2].toString()}.${i}`;
                                    if(arr8.includes(number)){
                                        const findEl = jsonNew.find(el=> el.address === number);
                                        const objeto = {};
                                        objeto.idForMikrotik = findEl?.comment;
                                        objeto.idFromMikrotik = findEl['.id'];
                                        objeto.isActive = findEl.list ? findEl.list === 'Moroso' ? false : true : false ;
                                        objeto.IP = number;
                                        objeto.Status = 'NO DISPONIBLE';
                                        arrComplete8.push(objeto);
                                    }else{
                                        const objeto = {};
                                        objeto.Status = 'DISPONIBLE';
                                        objeto.IP = number;
                                        arrComplete8.push(objeto);
                                    }
                                }
                                arrComp2 = arrComp2.concat(arrComplete8);
                            };
                            const arrNew_ = arrComp.map(el=>{
                                const objeto = {...el};
                                const arrF_ = arrComp2.find(el2=> el2.IP === el.IP);
                                objeto.idFromMikrotik = arrF_?.idFromMikrotik;
                                objeto.isActive = arrF_?.isActive;
                                return objeto;
                            })
                            setArrIp(arrNew_);
                            setIpsCharged(true);
                            
                        });        
                    }); 
                } else if(zonaSelected.simpleQueue){
                    fetch('/api/getIpsSimpleQueue', {
                        method: 'POST',
                        body: JSON.stringify({ InfoZona: zonaSelected }),
                        headers: { 'Content-Type': 'application/json' }
                    })
                    .then(response => response.json())
                    .then((result) => {
                        let arrComp = [];
                        for (const x in zonaSelected.Subnet) {
                            let data = zonaSelected.Subnet[x];
                            let rangeZone = data.Red.split('.');
                            const arr4 = [];
                            const arrComplete4 = [];
                            for (const x in result) {
                                for (const y in result[x]) {
                                    if (result[x][y].field === 'target') {
                                        if (result[x][y].value.split('/').length === 2) {
                                            let val_0 = result[x][y].value.split('/')[0].toString();
                                            let val = val_0.split('.');
                                            let range = `${val[0].toString()}.${val[1].toString()}.${val[2].toString()}.0`
                                            if (data.Red.toString() === range.toString()) arr4.push(val_0);
                                        }
                                    }
                                };
                            };
                            for (let i = 2; i < 255; i++) {
                                let number = `${rangeZone[0].toString()}.${rangeZone[1].toString()}.${rangeZone[2].toString()}.${i}`;
                                if (arr4.includes(number)) {
                                    const objeto = {};
                                    for (const x in result) {
                                        for (const y in result[x]) {
                                            if (result[x][y].field === 'target') {
                                                if (result[x][y].value.split('/').length === 2) {
                                                    let val_0 = result[x][y].value.split('/')[0].toString();
                                                    if (val_0 === number){ 
                                                        objeto.idForMikrotik = result[x][1].value;
                                                        objeto.idFromMikrotik = result[x][0].value;
                                                    }
                                                }
    
                                            }
                                        };
                                    };
                                    objeto.Status = 'NO DISPONIBLE';
                                    objeto.IP = number;
                                    arrComplete4.push(objeto);
                                } else {
                                    const objeto = {};
                                    objeto.Status = 'DISPONIBLE';
                                    objeto.IP = number;
                                    arrComplete4.push(objeto);
                                }
                            }
                            arrComp = arrComp.concat(arrComplete4);
                        }
                        setArrIp(arrComp);
                        setIpsCharged(true);
                        
                    });
                } else if(zonaSelected.queueTree) {
                    fetch('/api/getIpsQueueTree', {
                        method: 'POST',
                        body: JSON.stringify({ InfoZona: zonaSelected }),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(response => response.json())
                    .then((result) => {
                        let arrComp = [];
                        for (const x in zonaSelected.Subnet) {
                            let data = zonaSelected.Subnet[x];
                            let rangeZone = data.Red.split('.');
                            const arr4 = [];
                            const arrComplete4 = [];
                            for (const x in result) {
                                for (const y in result[x]) {
                                    if (result[x][y].field === 'address') {
                                        let val = result[x][y].value.split('.');
                                        let range = `${val[0].toString()}.${val[1].toString()}.${val[2].toString()}.0`
                                        if (data.Red.toString() === range.toString()) arr4.push(result[x][y].value);
                                    }
                                };
                            };
                            for (let i = 2; i < 255; i++) {
                                let number = `${rangeZone[0].toString()}.${rangeZone[1].toString()}.${rangeZone[2].toString()}.${i}`;
                                if (arr4.includes(number)) {
                                    const objeto = {};
                                    for (const x in result) {
                                        for (const y in result[x]) {
                                            if (result[x][y].field === 'address') {
                                                if (result[x][y].value === number){ 
                                                    objeto.idForMikrotik = result[x][6] ? result[x][6].value : null;
                                                    objeto.Plan = result[x][1].value;
                                                    objeto.idFromMikrotik = result[x][0].value;
                                                    objeto.isActive = result[x][1]?.value === 'Moroso' ? false : true;
                                                }
                                            }
                                        };
                                    };
                                    
                                    objeto.IP = number;
                                    objeto.Status = 'NO DISPONIBLE';
                                    arrComplete4.push(objeto);
                                } else {
                                    const objeto = {};
                                    objeto.Status = 'DISPONIBLE';
                                    objeto.IP = number;
                                    arrComplete4.push(objeto);
                                }
                            }
                            arrComp = arrComp.concat(arrComplete4);
                        };
                        setArrIp(arrComp);
                        setIpsCharged(true);
                        
                    });
                } else if(zonaSelected.ppoeList) {
                    fetch('/api/getIpsPPPoe', {
                        method: 'POST',
                        body: JSON.stringify({ InfoZona: zonaSelected }),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(response => response.json())
                    .then((result) => {
                        let arrComp = [];
                        for (const x in zonaSelected.Subnet) {
                            let data = zonaSelected.Subnet[x];
                            let rangeZone = data.Red.split('.');
                            const arr4 = [];
                            const arrComplete4 = [];
                            for (const x in result) {
                                for (const y in result[x]) {
                                    if (result[x][y].field === 'remote-address') {
                                        let val = result[x][y].value.split('.');
                                        let range = `${val[0].toString()}.${val[1].toString()}.${val[2].toString()}.0`
                                        if (data.Red.toString() === range.toString()) arr4.push(result[x][y].value);
                                    }
                                };
                            };
                            for (let i = 2; i < 255; i++) {
                                let number = `${rangeZone[0].toString()}.${rangeZone[1].toString()}.${rangeZone[2].toString()}.${i}`;
                                if (arr4.includes(number)) {
                                    const objeto = {};
                                    for (const x in result) {
                                        for (const y in result[x]) {
                                            if (result[x][y].field === 'remote-address') {
                                                if (result[x][y].value === number){ 
                                                    objeto.idForMikrotik = result[x][1].value;
                                                    objeto.idFromMikrotik = result[x][0].value;
                                                }
                                            }
                                        };
                                    };
                                    objeto.Status = 'NO DISPONIBLE';
                                    objeto.IP = number;
                                    arrComplete4.push(objeto);
                                } else {
                                    const objeto = {};
                                    objeto.Status = 'DISPONIBLE';
                                    objeto.IP = number;
                                    arrComplete4.push(objeto);
                                }
                            }
                            arrComp = arrComp.concat(arrComplete4);
                        };
                        fetch('/api/mikrotik/clientesPpoeListActive',{
                            method:'POST',
                            body: JSON.stringify(zonaSelected),
                            headers:{
                                'Content-Type': 'application/json'
                            }
                        }) 
                        .then(response2=> response2.json())
                        .then(result2 =>{
                            const arr2 = [];
                            result2.forEach(value => {
                                const objeto = {};
                                value.forEach((value2, index2)=>{
                                let splitKey =  value2.field.toString().split('-');
                                switch(splitKey.length){
                                    case 2: 
                                        let key2 = `${splitKey[0].toString()}${capitalize(splitKey[1])}`
                                        objeto[key2] = value2.value; 
                                        break;
                                    case 3: 
                                        let key3 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}`
                                        objeto[key3] = value2.value;
                                        break;
                                    case 4: 
                                        let key4 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}${capitalize(splitKey[3])}`
                                        objeto[key4] = value2.value;
                                        break;
                                    default:
                                        let splitKey2 =  value2.field.toString().split('.');
                                        if(splitKey2.length === 2){
                                        objeto.idGeneralActive = value2.value;
                                        }else{
                                        objeto[value2.field] = value2.value;                      
                                        }
                                        break;
                                }
                                })
                                arr2.push(objeto);
                            });
                            const arrActive = arr2.map(value=>value.address);
                            const arrResult = arrComp.map(value=>{
                                const objeto5 = {...value};
                                if(arrActive.includes(value.IP)){
                                    objeto5.isActive = true;
                                    return(objeto5);
                                }else{
                                    objeto5.isActive = false;
                                    return objeto5;
                                }
                            });
                            setArrIp(arrResult);
                            setIpsCharged(true);
                            
                        });
                    });
                }  
    
            })();
            setNewService(true);
            setPlanes(zonaSelected.planLocal ? zonaSelected.Planes : getPlanes);
            setDatosD({...DatosD, 
                idUiid:data.idUiid, 
                FOptica:data.FOptica, 
                TipoServicio:data.TipoServicio, 
                TipoServicioMk:data.TipoServicioMk, 
                ZonaService:zonaSelected.Zona, 
                TipoPagoBoolean:true, 
                CorteAutomatico:true, 
                Status:'Activo', 
                MacOnu:'', 
                SN:'', 
                MacRouter:'', 
                RouterNSerie:'',
                Ciudad:zonaSelected.Ciudad,
                Canton:zonaSelected.Canton,
                Parroquia:zonaSelected.Parroquia,
                Provincia:zonaSelected.Provincia
            }); 
            setInfoBackup({ MacOnu:'', MacRouter:''})
            setOnuBridge(false);
            (async()=>{
                const getEquiposA = await fetch(`/api/EquiposAls/byEmpresa/${authTokens.Empresa}`);
                const jsnEquiposA = await getEquiposA.json();
                setEquiposAll(jsnEquiposA);
                const getStock = await fetch(`/api/Stocks/byEmpresa/${authTokens.Empresa}`);
                const jsnStock = await getStock.json();
                setStock(jsnStock);
                const arr = jsnStock.filter(elR=>elR.Tipo === 'ROUTER');
                const arrCpe = jsnStock.filter(elR=>elR.Tipo === 'ONT');
                const arr_1 = arr.map(el=>el.Modelo);
                const arr_2 = new Set(arr_1);
                const arr_3 = [...arr_2];
                const arr_4 = arrCpe.map(el=>el.Modelo);
                const arr_5 = new Set(arr_4);
                const arr_6 = [...arr_5];
                setOnlyRouters(arr_3);
                setOnlyOnts(arr_6);
            })();
            var map = new mapboxgl.Map({
                container: mapDiv.current,
                style: 'mapbox://styles/mapbox/satellite-v9',
                center: [ 
                    data.Coordenadas === '' ? '-79.93395424851998' : 
                    data.Coordenadas === undefined ? '-79.93395424851998' : data.Coordenadas.split(',')[1], 
                    data.Coordenadas === '' ? '-2.201567808901885' : 
                    data.Coordenadas === undefined ? '-2.201567808901885' : data.Coordenadas.split(',')[0] ] ,
                zoom: 16.80
            });
    
            const marker = new mapboxgl.Marker();
                marker.id = data._id;
                marker
                    .setLngLat(
                        [ 
                            data.Coordenadas === '' ? '-79.93395424851998' : 
                            data.Coordenadas === undefined ? '-79.93395424851998' : data.Coordenadas.split(',')[1], 
                            data.Coordenadas === '' ? '-2.201567808901885' : 
                            data.Coordenadas === undefined ? '-2.201567808901885' : data.Coordenadas.split(',')[0] ]
                    )
                    .addTo( map )
                    .setDraggable(true)
    
                marker.on('dragend', ({target})=>{
                    setCoord(`${target._lngLat.lat.toString()}, ${target._lngLat.lng.toString()}`);
                })
    
            mapa.current = map;
        }else{
            // console.log(zonaSelected.sysintercom)
            (async ()=>{
                if (zonaSelected.isIptv) {
                    fetch('/api/getIpsQueueTree', {
                        method: 'POST',
                        body: JSON.stringify({ InfoZona: zonaSelected }),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(response => response.json())
                    .then((result) => {
                        let arrComp = [];
                        for (const x in zonaSelected.SubnetIptv) {
                            let data = zonaSelected.SubnetIptv[x];
                            let rangeZone = data.Red.split('.');
                            const arr4 = [];
                            const arrComplete4 = [];
                            for (const x in result) {
                                for (const y in result[x]) {
                                    if (result[x][y].field === 'address') {
                                        let val = result[x][y].value.split('.');
                                        let range = `${val[0].toString()}.${val[1].toString()}.${val[2].toString()}.0`
                                        if (data.Red.toString() === range.toString()) arr4.push(result[x][y].value);
                                    }
                                };
                            };
                            for (let i = 2; i < 255; i++) {
                                let number = `${rangeZone[0].toString()}.${rangeZone[1].toString()}.${rangeZone[2].toString()}.${i}`;
                                if (arr4.includes(number)) {
                                    const objeto = {};
                                    for (const x in result) {
                                        for (const y in result[x]) {
                                            if (result[x][y].field === 'address') {
                                                if (result[x][y].value === number) objeto.idForMikrotik = result[x][6] ? result[x][6].value : null
                                            }
                                        };
                                    };
                                    objeto.IP = number;
                                    objeto.Status = 'NO DISPONIBLE';
                                    arrComplete4.push(objeto);
                                } else {
                                    const objeto = {};
                                    objeto.Status = 'DISPONIBLE';
                                    objeto.IP = number;
                                    arrComplete4.push(objeto);
                                }
                            }
                            arrComp = arrComp.concat(arrComplete4);
                        };
                        setArrIpIptv(arrComp);
                        const arrIptv = [];
                        for(const x in arrComp){
                            let redIp = arrComp[x].IP.split('.');
                            let red = `${redIp[0].toString()}.${redIp[1].toString()}.${redIp[2].toString()}.0`
                            if(red.toString() === data.RedIptv.toString()) arrIptv.push(arrComp[x]);
                        };
                        setArrIpServiceIptv(arrIptv);
                    });
                }
                
                if(zonaSelected.sysintercom){
                    fetch('/api/getIpsSimpleQueue',{
                        method:'POST',
                        body: JSON.stringify({InfoZona:zonaSelected}),
                        headers:{'Content-Type': 'application/json'}
                    }) 
                    .then(response=> response.json())
                    .then((result) =>{
                        let arrComp = [];
                        for(const x in zonaSelected.Subnet){
                            let data = zonaSelected.Subnet[x];
                            let rangeZone = data.Red.split('.');
                            const arr4 = [];
                            const arrComplete4 = [];
                            for(const x in result){
                                for(const y in result[x]){
                                    if(result[x][y].field === 'target'){ 
                                        if(result[x][y].value.split('/').length === 2){
                                            let val_0 = result[x][y].value.split('/')[0].toString();
                                            let val = val_0.split('.');
                                            if(val.length > 2){
                                                let range = `${val[0].toString()}.${val[1].toString()}.${val[2]?.toString()}.0`
                                                if(data.Red.toString() === range.toString()) arr4.push(val_0);
                                            }
                                        }
                                    }
                                };
                            };
                            for(let i = 2; i < 255; i++ ){
                                let number = `${rangeZone[0].toString()}.${rangeZone[1].toString()}.${rangeZone[2].toString()}.${i}`;
                                if(arr4.includes(number)){
                                    const objeto = {};
                                    for(const x in result){
                                        for(const y in result[x]){
                                            if(result[x][y].field === 'target'){ 
                                                if(result[x][y].value.split('/').length === 2){
                                                    let val_0 = result[x][y].value.split('/')[0].toString();
                                                    if(val_0 === number) {
                                                        objeto.idForMikrotik = result[x][1].value ;
                                                        objeto.idFromMikrotikSimple = result[x][0].value ;
                                                    }
                                                }
    
                                            }
                                        };
                                    };
                                    objeto.Status = 'NO DISPONIBLE';
                                    objeto.IP = number;
                                    arrComplete4.push(objeto);                                           
                                }else{
                                    const objeto = {};
                                    objeto.Status = 'DISPONIBLE';
                                    objeto.IP = number;
                                    arrComplete4.push(objeto);
                                }
                            }
                            arrComp = arrComp.concat(arrComplete4);
                        };
                        fetch('/api/getIpsQueueTree',{
                            method:'POST',
                            body: JSON.stringify({InfoZona:zonaSelected}),
                            headers:{
                                'Content-Type': 'application/json'
                            }
                        }) 
                        .then(response=> response.json())
                        .then(async (result2) =>{    
                            const jsonNew = await ConvertArrToJson(result2);
                            let arrComp2 = [];
                            for(const x in zonaSelected.Subnet){
                                let data = zonaSelected.Subnet[x];
                                let rangeZone = data.Red.split('.');
                                const arrComplete8 = [];
                                
                                const arr8 = jsonNew.filter(el=>{
                                    let val = el.address?.split('.');
                                    if(val.length > 2){
                                        let range = `${val[0].toString()}.${val[1].toString()}.${val[2]?.toString()}.0`;
                                        if(data.Red.toString() === range.toString()) return true;
                                        else  return false;
                                    }else{
                                        return false; 
                                    }
                                }).map(el=>el.address).splice(1);
    
                                for(let i = 2; i < 255; i++ ){
                                    let number = `${rangeZone[0].toString()}.${rangeZone[1].toString()}.${rangeZone[2].toString()}.${i}`;
                                    if(arr8.includes(number)){
                                        const findEl = jsonNew.find(el=> el.address === number);
                                        const findElOtt = jsonNew.find(el=> el.address === number && el.list === "Permitir_OTT")
                                        const objeto = {};
                                        objeto.idForMikrotik = findEl?.comment;
                                        objeto.idFromMikrotik = findEl['.id'];
                                        findEl.list && console.log(findEl.list)
                                        objeto.isActive = findEl.list ? findEl.list === 'Moroso' ? false : true : false ;
                                        objeto.isOtt = findElOtt ? findElOtt.list === 'Permitir_OTT' ? true : false : false ;
                                        objeto.IP = number;
                                        objeto.Status = 'NO DISPONIBLE';
                                        arrComplete8.push(objeto);
                                    }else{
                                        const objeto = {};
                                        objeto.Status = 'DISPONIBLE';
                                        objeto.IP = number;
                                        arrComplete8.push(objeto);
                                    }
                                }
                                arrComp2 = arrComp2.concat(arrComplete8);
                            };
                            const arrNew_ = arrComp.map(el=>{
                                const objeto = {...el};
                                const arrF_ = arrComp2.find(el2=> el2.IP === el.IP);
                                objeto.idFromMikrotik = arrF_?.idFromMikrotik;
                                objeto.isActive = arrF_?.isActive;
                                objeto.isOtt = arrF_?.isOtt;
                                return objeto;
                            })
                            const findIp = arrNew_.find(el=> el.IP === data.AddressIp);
                            findIp?.isActive && setServActive(true);
                            findIp?.isOtt && setOttActive(true);
                            const arr2_ = [];
                            for(const x in arrNew_){
                                let redIp = arrNew_[x].IP.split('.');
                                let red = `${redIp[0].toString()}.${redIp[1].toString()}.${redIp[2].toString()}.0`
                                if(red.toString() === data.Red.toString()) arr2_.push(arrNew_[x]);
                            };
                            setArrIpService(arr2_);
                            setArrIp(arrNew_);
                            setIpsCharged(true);
                        });        
                    });
                } else if(zonaSelected.simpleQueue){
                    fetch('/api/getIpsSimpleQueue', {
                        method: 'POST',
                        body: JSON.stringify({ InfoZona: zonaSelected }),
                        headers: { 'Content-Type': 'application/json' }
                    })
                    .then(response => response.json())
                    .then((result) => {
                        let arrComp = [];
                        for (const x in zonaSelected.Subnet) {
                            let data = zonaSelected.Subnet[x];
                            let rangeZone = data.Red.split('.');
                            const arr4 = [];
                            const arrComplete4 = [];
                            for (const x in result) {
                                for (const y in result[x]) {
                                    if (result[x][y].field === 'target') {
                                        if (result[x][y].value.split('/').length === 2) {
                                            let val_0 = result[x][y].value.split('/')[0].toString();
                                            let val = val_0.split('.');
                                            let range = `${val[0].toString()}.${val[1].toString()}.${val[2].toString()}.0`
                                            if (data.Red.toString() === range.toString()) arr4.push(val_0);
                                        }
                                    }
                                };
                            };
                            for (let i = 2; i < 255; i++) {
                                let number = `${rangeZone[0].toString()}.${rangeZone[1].toString()}.${rangeZone[2].toString()}.${i}`;
                                if (arr4.includes(number)) {
                                    const objeto = {};
                                    for (const x in result) {
                                        for (const y in result[x]) {
                                            if (result[x][y].field === 'target') {
                                                if (result[x][y].value.split('/').length === 2) {
                                                    let val_0 = result[x][y].value.split('/')[0].toString();
                                                    if (val_0 === number){ 
                                                        objeto.idForMikrotik = result[x][1].value;
                                                        objeto.idFromMikrotik = result[x][0].value;
                                                    }
                                                }
    
                                            }
                                        };
                                    };
                                    objeto.Status = 'NO DISPONIBLE';
                                    objeto.IP = number;
                                    arrComplete4.push(objeto);
                                } else {
                                    const objeto = {};
                                    objeto.Status = 'DISPONIBLE';
                                    objeto.IP = number;
                                    arrComplete4.push(objeto);
                                }
                            }
                            arrComp = arrComp.concat(arrComplete4);
                        }
                        const findIp = arrComp.find(el=> el.IP === data.AddressIp);
                        findIp?.isActive && setServActive(true);
                        const arr2_ = [];
                        for(const x in arrComp){
                            let redIp = arrComp[x].IP.split('.');
                            let red = `${redIp[0].toString()}.${redIp[1].toString()}.${redIp[2].toString()}.0`
                            if(red.toString() === data.Red.toString()) arr2_.push(arrComp[x]);
                        };
                        setArrIpService(arr2_);
                        setArrIp(arrComp);
                        setIpsCharged(true);
                    });
                } else if(zonaSelected.queueTree) {
                    fetch('/api/getIpsQueueTree', {
                        method: 'POST',
                        body: JSON.stringify({ InfoZona: zonaSelected }),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(response => response.json())
                    .then((result) => {
                        let arrComp = [];
                        for (const x in zonaSelected.Subnet) {
                            let data = zonaSelected.Subnet[x];
                            let rangeZone = data.Red.split('.');
                            const arr4 = [];
                            const arrComplete4 = [];
                            for (const x in result) {
                                for (const y in result[x]) {
                                    if (result[x][y].field === 'address') {
                                        let val = result[x][y].value.split('.');
                                        let range = `${val[0].toString()}.${val[1].toString()}.${val[2].toString()}.0`
                                        if (data.Red.toString() === range.toString()) arr4.push(result[x][y].value);
                                    }
                                };
                            };
                            for (let i = 2; i < 255; i++) {
                                let number = `${rangeZone[0].toString()}.${rangeZone[1].toString()}.${rangeZone[2].toString()}.${i}`;
                                if (arr4.includes(number)) {
                                    const objeto = {};
                                    for (const x in result) {
                                        for (const y in result[x]) {
                                            if (result[x][y].field === 'address') {
                                                if (result[x][y].value === number){ 
                                                    objeto.idForMikrotik = result[x][6] ? result[x][6].value : null;
                                                    objeto.Plan = result[x][1].value;
                                                    objeto.idFromMikrotik = result[x][0].value;
                                                    objeto.isActive = result[x][1]?.value === 'Moroso' ? false : true;
                                                }
                                            }
                                        };
                                    };
                                    
                                    objeto.IP = number;
                                    objeto.Status = 'NO DISPONIBLE';
                                    arrComplete4.push(objeto);
                                } else {
                                    const objeto = {};
                                    objeto.Status = 'DISPONIBLE';
                                    objeto.IP = number;
                                    arrComplete4.push(objeto);
                                }
                            }
                            arrComp = arrComp.concat(arrComplete4);
                        };
                        const findIp = arrComp.find(el=> el.IP === data.AddressIp);
                        findIp?.isActive && setServActive(true);
                        const arr2_ = [];
                        for(const x in arrComp){
                            let redIp = arrComp[x].IP.split('.');
                            let red = `${redIp[0].toString()}.${redIp[1].toString()}.${redIp[2].toString()}.0`
                            if(red.toString() === data.Red.toString()) arr2_.push(arrComp[x]);
                        };
                        setArrIpService(arr2_);
                        setArrIp(arrComp);
                        setIpsCharged(true);
                        
                    });
                } else if(zonaSelected.ppoeList) {
                    fetch('/api/getIpsPPPoe', {
                        method: 'POST',
                        body: JSON.stringify({ InfoZona: zonaSelected }),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(response => response.json())
                    .then((result) => {
                        let arrComp = [];
                        for (const x in zonaSelected.Subnet) {
                            let data = zonaSelected.Subnet[x];
                            let rangeZone = data.Red.split('.');
                            const arr4 = [];
                            const arrComplete4 = [];
                            for (const x in result) {
                                for (const y in result[x]) {
                                    if (result[x][y].field === 'remote-address') {
                                        let val = result[x][y].value.split('.');
                                        let range = `${val[0].toString()}.${val[1].toString()}.${val[2].toString()}.0`
                                        if (data.Red.toString() === range.toString()) arr4.push(result[x][y].value);
                                    }
                                };
                            };
                            for (let i = 2; i < 255; i++) {
                                let number = `${rangeZone[0].toString()}.${rangeZone[1].toString()}.${rangeZone[2].toString()}.${i}`;
                                if (arr4.includes(number)) {
                                    const objeto = {};
                                    for (const x in result) {
                                        for (const y in result[x]) {
                                            if (result[x][y].field === 'remote-address') {
                                                if (result[x][y].value === number){ 
                                                    objeto.idForMikrotik = result[x][1].value;
                                                    objeto.idFromMikrotik = result[x][0].value;
                                                }
                                            }
                                        };
                                    };
                                    objeto.Status = 'NO DISPONIBLE';
                                    objeto.IP = number;
                                    arrComplete4.push(objeto);
                                } else {
                                    const objeto = {};
                                    objeto.Status = 'DISPONIBLE';
                                    objeto.IP = number;
                                    arrComplete4.push(objeto);
                                }
                            }
                            arrComp = arrComp.concat(arrComplete4);
                        };
                        fetch('/api/mikrotik/clientesPpoeListActive',{
                            method:'POST',
                            body: JSON.stringify(zonaSelected),
                            headers:{
                                'Content-Type': 'application/json'
                            }
                        }) 
                        .then(response2=> response2.json())
                        .then(result2 =>{
                            const arr2 = [];
                            result2.forEach(value => {
                                const objeto = {};
                                value.forEach((value2, index2)=>{
                                let splitKey =  value2.field.toString().split('-');
                                switch(splitKey.length){
                                    case 2: 
                                        let key2 = `${splitKey[0].toString()}${capitalize(splitKey[1])}`
                                        objeto[key2] = value2.value; 
                                        break;
                                    case 3: 
                                        let key3 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}`
                                        objeto[key3] = value2.value;
                                        break;
                                    case 4: 
                                        let key4 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}${capitalize(splitKey[3])}`
                                        objeto[key4] = value2.value;
                                        break;
                                    default:
                                        let splitKey2 =  value2.field.toString().split('.');
                                        if(splitKey2.length === 2){
                                        objeto.idGeneralActive = value2.value;
                                        }else{
                                        objeto[value2.field] = value2.value;                      
                                        }
                                        break;
                                }
                                })
                                arr2.push(objeto);
                            });
                            const arrActive = arr2.map(value=>value.address);
                            const arrResult = arrComp.map(value=>{
                                const objeto5 = {...value};
                                if(arrActive.includes(value.IP)){
                                    objeto5.isActive = true;
                                    return(objeto5);
                                }else{
                                    objeto5.isActive = false;
                                    return objeto5;
                                }
                            });
                            const findIp = arrResult.find(el=> el.IP === data.AddressIp);
                            findIp?.isActive && setServActive(true);
                            const arr2_ = [];
                            for(const x in arrResult){
                                let redIp = arrResult[x].IP.split('.');
                                let red = `${redIp[0].toString()}.${redIp[1].toString()}.${redIp[2].toString()}.0`
                                if(red.toString() === data.Red.toString()) arr2_.push(arrResult[x]);
                            };
                            setArrIpService(arr2_);
                            setArrIp(arrResult);
                            setIpsCharged(true);
                        });
                    });
                }  
            })();
            setNewService(false);
            setDatosD(data); 
            setInfoBackup(data);
            setStatusServicioAdd(false);
            setCreateInstalacion(false);
            setCreateInvoice(false);
            setPlanes(zonaSelected.planLocal ? zonaSelected.Planes : getPlanes);
            const  handleSearchEl = async ()=>{
                const getEquiposA = await fetch(`/api/EquiposAls/byEmpresa/${authTokens.Empresa}`);
                const jsnEquiposA = await getEquiposA.json();
                setEquiposAll(jsnEquiposA);
                const getStock = await fetch(`/api/Stocks/byEmpresa/${authTokens.Empresa}`);
                const jsnStock = await getStock.json();
                setStock(jsnStock);
                const arr = jsnStock.filter(elR=>elR.Tipo === 'ROUTER');
                const arrCpe = jsnStock.filter(elR=>elR.Tipo === 'ONT');
                const arr_1 = arr.map(el=>el.Modelo);
                const arr_2 = new Set(arr_1);
                const arr_3 = [...arr_2];
                const arr_4 = arrCpe.map(el=>el.Modelo);
                const arr_5 = new Set(arr_4);
                const arr_6 = [...arr_5];
                setOnlyRouters(arr_3);
                setOnlyOnts(arr_6);
                if(data.MacOnu){
                    if(data.MacOnu !== '' && data.MacOnu !== undefined && data.MacOnu !== null  && data.MacOnu !== ' '){
                        const arrFiltradoOnu = jsnStock.find(el=> el.Mac === data.MacOnu);
                        if(arrFiltradoOnu !== undefined ){
                            if(!arrFiltradoOnu.Bridge){
                                setOnuBridge(false);
                            }
                        }
                    }
                }
            }; handleSearchEl();  
            setArrPhotos(data.FotosReferencia ? data.FotosReferencia.length > 0 ? data.FotosReferencia : [] : []);
            if(data.Coordenadas !== undefined ){
                if(isValidCoordinates(data.Coordenadas)){
                    setCoord(data.Coordenadas)
                }
            } 
            var map_ = new mapboxgl.Map({
                container: mapDiv.current,
                style: 'mapbox://styles/mapbox/satellite-v9',
                center: [ 
                    data.Coordenadas === '' ? '-79.93395424851998' : 
                    data.Coordenadas === undefined ? '-79.93395424851998' : 
                    isValidCoordinates(data.Coordenadas) ? 
                    data.Coordenadas.split(',')[1] : '-79.93395424851998', 
                    data.Coordenadas === '' ? '-2.201567808901885' : 
                    data.Coordenadas === undefined ? '-2.201567808901885' : 
                    isValidCoordinates(data.Coordenadas) ? 
                    data.Coordenadas.split(',')[0]  : '-2.201567808901885' ]
                    ,
                zoom: 16.80
            });
    
            const marker = new mapboxgl.Marker();
                marker.id = data._id;
                marker
                    .setLngLat(
                        [ 
                            data.Coordenadas === '' ? '-79.93395424851998' : 
                            data.Coordenadas === undefined ? '-79.93395424851998' : 
                            isValidCoordinates(data.Coordenadas) ? 
                            data.Coordenadas.split(',')[1] : '-79.93395424851998', 
                            data.Coordenadas === '' ? '-2.201567808901885' : 
                            data.Coordenadas === undefined ? '-2.201567808901885' : 
                            isValidCoordinates(data.Coordenadas) ? 
                            data.Coordenadas.split(',')[0]  : '-2.201567808901885' ]
                    )
                    .addTo( map_ )
                    .setDraggable(true)
    
                marker.on('dragend', ({target})=>{
                    setCoord(`${target._lngLat.lat.toString()}, ${target._lngLat.lng.toString()}`);
                })
    
            mapa.current = map_;
        }
    },[]);// eslint-disable-line react-hooks/exhaustive-deps

    const handleDatos = ({target})=>{ 
        if(target.id === 'Direccion' || target.id ==='Referencia' || target.id === 'Canton' || target.id === 'Provincia' || target.id === 'Parroquia' || target.id === 'Ciudad'){
            setDatosD({...DatosD, [target.id]:target.value.toUpperCase()}) 
        }else{
            setDatosD({...DatosD, [target.id]:target.value}) 
        }
        
    };

    const handleTipoPago = (checked)=>{
        if(checked){
            setDatosD({...DatosD, TipoPago:'PrePago', TipoPagoBoolean:checked});
        }else{
            setDatosD({...DatosD, TipoPago:'PostPago', TipoPagoBoolean:checked});
        }
    };

    const handleDeleteServicio = ()=>{
        if(statusServicioAdd){
            swal({
                title: "Desea Eliminar este Servicio Nuevo?",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
            .then((value) => {
                if(value){
                    handleBorrarServicio(data);
                }
            });
        }else{
            const objetoDele = {};
            const objetoZ = [...dataCliente.Zonas];
            const indexZ = objetoZ.indexOf(DatosD.ZonaService);
            const objetoZ_ = objetoZ.filter((el,index)=> index !== indexZ);
            objetoDele.Zonas = objetoZ_;
            objetoDele._id = DatosD._id;
            objetoDele.idCliente = dataCliente._id;
            objetoDele.idUiid = data.idUiid;
            objetoDele.idFromMikrotik = DatosD.idFromMikrotik;
            objetoDele.InfoZona = zonaSelected;
            objetoDele.TipoServicioMk = DatosD.TipoServicioMk;
            objetoDele.idForMikrotik = DatosD.idForMikrotik;
            objetoDele.idFromMikrotikSimple = DatosD.idFromMikrotikSimple ? DatosD.idFromMikrotikSimple : '';
            objetoDele.AddressIp = DatosD.AddressIp;
            objetoDele.isOnuBridge = isOnuBridge;
            objetoDele.MacOnu = DatosD.MacOnu;
            objetoDele.MacRouter = DatosD.MacRouter;
            objetoDele.FOptica = true;
            objetoDele.ZonaCliente = DatosD.ZonaService;
            swal({
                title: "Desea Eliminar este Servicio?",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then((value)=>{
                if(value){
                    fetch('/api/clientes/servicios',{
                        method:'DELETE',
                        body: JSON.stringify(objetoDele),
                        headers:{'Content-Type': 'application/json'}
                    }) 
                    .then(response=> response.json())
                    .then(result =>{
                        
                        if(result.message){
                            const objeto3 = {};
                            objeto3.idCliente = dataCliente._id;
                            objeto3.Servicio = DatosD;
                            handleBorrarServicioMongo(data);
                            enqueueSnackbar('SERVICIO ELIMINADO',{variant:'success'});    
                        }else{
                            if(result.status === "Error, no such item (4)"){
                                swal({
                                    title: "No existe este Servicio en el Mikrotik, desea proceder con la eliminacion",
                                    icon: "warning",
                                    buttons: true,
                                    dangerMode: true,
                                })
                                .then((value) => {
                                    if(value){
                                        objetoDele.InfoZona.AddClientMikrotik = false;
                                        fetch('/api/clientes/servicios',{
                                            method:'DELETE',
                                            body: JSON.stringify(objetoDele),
                                            headers:{
                                                'Content-Type': 'application/json'
                                            }
                                        }) 
                                        .then(response=> response.json())
                                        .then(result =>{
                                            
                                            if(result.message){
                                                handleBorrarServicio(data.idUiid);
                                            }else{
                                                enqueueSnackbar(`Error ${result.status}`,{variant:'error'});
                                            }
                                        })
                                    }
                                });
                            }else{
                                enqueueSnackbar(`Error ${result.status}`,{variant:'error'});
                            }
                            
                        }
                    });
                }
            })
            
        }
        
    };

    const handleAlertSaveServicio = ()=>{
        setSaving(true);
        swal({
            title: "Desea Guardar este Servicio?",
            icon: "info",
            buttons: true,
        })
        .then((value) => {
            if(value){
                if(data.Status === 'Suspendido'){
                    handleSubSaveServicio(false);
                }else{ 
                    handleValidacion();
                }
                
            }else{
                setTimeout(()=>{
                    setSaving(false);
                },500)
            }
        });
        
    };

    const handleValidacion = ()=>{
        if(DatosD.Instalacion === '' && !DatosD.isFree){
            enqueueSnackbar('Ingrese Fecha de Instalacion',{variant:'error'});
            setSaving(false);
        }else if(DatosD.AddressIp === ''){
            enqueueSnackbar('Ingrese Direccion IP',{variant:'error'});
            setSaving(false);
        }else if(DatosD.Plan === ''){
            enqueueSnackbar('Seleccione un Plan',{variant:'error'});
            setSaving(false);
        }else if(DatosD.ValorInstalacion === '' && !DatosD.isFree ){
            enqueueSnackbar('Valor Instalacion',{variant:'error'});
            setSaving(false);
        }else if(DatosD.DiasCorte === '' && !DatosD.isFree ){
            enqueueSnackbar('Ingrese los Dias de Corte',{variant:'error'});
            setSaving(false);
        }else if(data.isNew && DatosD.MacOnu === '' && !DatosD.isFree ){
            enqueueSnackbar('Seleccione Una Mac Onu o SN',{variant:'error'});
            setSaving(false);
        }else if(DatosD.DiaNotificacion === '' && !DatosD.isFree){
            enqueueSnackbar('Ingrese Dia de Notificacion',{variant:'error'});
            setSaving(false);
        }else if(isOnuBridge && DatosD.MacRouter === '' && !DatosD.isFree){ 
            enqueueSnackbar('Seleccione Una Mac Router',{variant:'error'});
            setSaving(false);
        }else if(zonaSelected.AddClientMikrotik && DatosD.idForMikrotik === ''){
            enqueueSnackbar('Ingrese id For Mikrotik',{variant:'error'});
            setSaving(false);
        }else{
            handleValidateMac();
        }
       
    };

    const handleValidateMac = ()=>{
        if(DatosD.isFree){
            handleSubSaveServicio(true);
        }else{
            if(DatosD.MacOnu === getInfoBackup.MacOnu){
                if(isOnuBridge){
                    if(DatosD.MacRouter === getInfoBackup.MacRouter){
                        handleSubSaveServicio(false);
                    }else{
                        handleSubSaveServicio(true);
                    }
                }else{
                    handleSubSaveServicio(false);
                } 
            }else{
                handleSubSaveServicio(true);
            }
        }
    };

    const handleSubSaveServicio = (valiMac)=>{
        let objeto = {...DatosD};
        let objetoZona = {...zonaSelected};
        let objeto_ = {...getInfoBackup};
        const objetoZ = [...dataCliente.Zonas];
        objetoZ.push(zonaSelected.Zona);
        objetoZona.AddClientMikrotik = getAddClientMikrotik;
        objetoZona.Planes = zonaSelected.planLocal ? zonaSelected.Planes : getPlanes;
        objeto.idCliente = dataCliente._id;
        objeto.CI = dataCliente.CI;
        objeto.Correo = dataCliente.Correo.map(elCorreo=> elCorreo.correo);
        objeto.InfoZona = objetoZona;
        objeto.Vendedor = authTokens.Nombres;
        objeto.data = dataCliente;
        objeto.sendCorreo = DatosD.isFree ? false : isNotificacion;
        objeto.Nombres = `${dataCliente.Nombres} || ${DatosD.idForMikrotik}`;
        objeto.Nombres2 = dataCliente.Nombres;
        objeto.isChangeMac = valiMac;
        objeto.isOnuBridge = DatosD.isFree ? true : isOnuBridge;
        objeto.MacOnu_New = DatosD.MacOnu ;
        objeto.MacOnu_Back = objeto_.MacOnu;
        objeto.MacRouter_New = DatosD.MacRouter;
        objeto.MacRouter_Back = objeto_.MacRouter;
        objeto.AvanceInstalacion = getAvance;
        objeto.isNew = isNewService;
        objeto.FotosReferencia = getArrPhotos;
        objeto.Coordenadas = getCoord;
        objeto.Zonas = objetoZ;
        objeto.idUiid =  `${dataCliente.CI}_${uuidv4()}`;
        objeto.TipoPago = objeto.TipoPagoBoolean ? 'PrePago' : 'PostPago';
        objeto.isIp = true;
        objeto.Empresa = authTokens.Empresa;
        objeto.isCreateInvoice = DatosD.isFree ? false : isCreateInvoice;
        objeto.isCreateInstalacion = DatosD.isFree ? false : isCreateInstalacion;
        objeto.isUnify = isUnify;
        if(statusServicioAdd){
            fetch('/api/clientes/servicios',{
                method:'POST',
                body: JSON.stringify(objeto),
                headers:{
                    'Content-Type': 'application/json'
                }
            }) 
            .then(response=> response.json())
            .then(result =>{
                setSaving(false);
                if(result._id){
                    setStatusServicioAdd(false);
                    handlePostServicio(result);
                    setDatosD({...DatosD, 
                        _id:result._id, 
                        Registro:result.Registro, 
                        isNew:false, 
                        idFromMikrotik:result.idFromMikrotik, 
                        TipoServicioMk:result.TipoServicioMk, 
                        idFromMikrotikSimple:result.idFromMikrotikSimple,
                        NumberServiceClient:result.NumberServiceClient,
                    });   

                    const objeto2 = {...DatosD};
                    objeto2._id = result._id;
                    objeto2.Registro = result.Registro;
                    objeto2.idFromMikrotik = result.idFromMikrotik;
                    objeto2.idFromMikrotikSimple = result.idFromMikrotikSimple;
                    objeto2.TipoServicioMk = result.TipoServicioMk;
                    objeto2.NumberServiceClient = result.NumberServiceClient;
                          
                    enqueueSnackbar('SERVICIO GUARDADO',{variant:'success'});    
                    setInfoBackup(objeto2); 
                }else{ 
                    enqueueSnackbar(`Error ${result.status}`,{variant:'error'});    
                }
            });
        }else{
            fetch('/api/clientes/servicios',{
                method:'PUT',
                body: JSON.stringify(objeto),
                headers:{
                    'Content-Type': 'application/json'
                }
            }) 
            .then(response=> response.json())
            .then(result =>{
                setSaving(false);
                if(result.message){
                    handlePutServicio(DatosD);             
                    enqueueSnackbar('CLIENTE EDITADO',{variant:'success'});
                    setInfoBackup(DatosD); 
                }else{
                    enqueueSnackbar(`Error ${result.status}`,{variant:'error'});    
                }
               
            });
        }
    };

    const handleStatusIns = ({target})=>{ setDatosD({...DatosD, StatusIns:target.checked})};

    const handleNotificacion = ({target})=>{setNotificacion(target.checked);};

    const handleDatosIdMikrotik = ({target})=>{ setDatosD({...DatosD, idForMikrotik:target.value, UserPPOE:target.value});};

    const handlePlanes = (e,value)=>{
        if(value === null || value === ''){
            setDatosD({...DatosD, Plan:'', ValPlan:0, PlanComercial:''});
        }else{
            const selectPlan = Planes.filter(el=>el.PlanComercial ===  value);
            if(selectPlan.length > 0) setDatosD({...DatosD, PlanComercial:value, ValPlan:selectPlan[0].Valor, Plan:selectPlan[0].Plan});
        }        
    };

    const handleCreatePdf = ()=>{setReadyPdf(true);};

    const handleClickPdf = useCallback(()=>{
        setTimeout(()=>{
            setReadyPdf(false);
        },[2000]);
    },[]);

    const handleDatosSelect = ({target})=>{ 
        const filterTecnico = getTecnicos.find(el=> el.NombresReducidos === target.value);
        setDatosD({...DatosD, TecnicoAsignado:target.value, TecnicoNombresCompletos:filterTecnico.Nombres});
    };

    const handleCuentasSelect = ({target})=>{ setDatosD({...DatosD, TipoCuenta:target.value}) };
    
    const handleDatosInstalacion = ({target})=>{ setDatosD({...DatosD, Instalacion:target.value}); };

    const handleOnus = (e, value, reason)=>{
        if(reason === 'select-option'){
            const filterEq = getEquiposAll.find(el =>el.Modelo === value);
            const arr = stock.filter(elStock=> elStock.Modelo === value);
            setDatosD({...DatosD, Onu:value, MacOnu:'', SN:'', OnuMarca:filterEq?.Marca });
            const arr1 = arr.filter(elStock=> elStock.Mac !== null && elStock.Mac !== undefined && elStock.Mac !== '');
            const arr2 = arr.filter(elStock=> elStock.SN !== null && elStock.SN  !== undefined && elStock.SN  !== '');
            setMacsOntArr(arr1.filter(el=>el.Status === 'Disponible'));
            setSnOntArr(arr2.filter(el=>el.Status === 'Disponible'));
            setOnuBridge(false);
        }else{
            setDatosD({...DatosD, Onu:'', MacOnu:'', SN:'', OnuMarca:'' })
            setOnuBridge(false);
            setMacsOntArr([]);
            setSnOntArr([]);
        }
    };

    const handleRouters = (e, value, reason)=>{
        if(reason === 'select-option'){
            setDatosD({...DatosD, Router:value, MacRouter:'', RouterNSerie:''  });
            const arr = stock.filter(elStock=> elStock.Modelo === value);
            const arr1 = arr.filter(elStock=> elStock.Mac !== null && elStock.Mac !== undefined && elStock.Mac !== '');
            const arr2 = arr.filter(elStock=> elStock.SN !== null && elStock.SN  !== undefined && elStock.SN  !== '');
            setMacsRouters(arr1.filter(el=>el.Status === 'Disponible'));
            setSnRouterArr(arr2.filter(el=>el.Status === 'Disponible'));
        }else{
            setDatosD({...DatosD, Router:'', MacRouter:'', RouterNSerie:''})
            setMacsRouters([]);
            setSnRouterArr([]);
        }
    };

    const handleSelectMacRouter = (e, value, reason)=>{ 
        if(value !== ''){
            const arrFilter = snRouterArr.filter(el=> el.Mac === value);
            if(arrFilter.length > 0 ){
                setDatosD({...DatosD, MacRouter:value, RouterNSerie:arrFilter[0].SN});
            }else{
                setDatosD({...DatosD, MacRouter:value, RouterNSerie:''});
            }
        }else{
            setDatosD({...DatosD, MacRouter:'', RouterNSerie:''});
        }
    };

    const handleSelectMacOnu = (e, value, reason)=>{ 
        if(value !== ''){
            const arrFilter = snOntArr.filter(el=> el.Mac === value);
            if(arrFilter.length > 0 ){
                setDatosD({...DatosD, MacOnu:value, SN:arrFilter[0].SN, OnuMarca:arrFilter[0].Marca, MacRouter:'', RouterNSerie:'', Router:''});
                const arrFiltradoOnu = stock.filter(el=> el.Mac === value)
                if(arrFiltradoOnu.length > 0){
                    if(arrFiltradoOnu[0].Bridge)setOnuBridge(true); 
                }
            }else{
                setDatosD({...DatosD, MacOnu:value, SN:'', OnuMarca:'', MacRouter:'', RouterNSerie:'', Router:''});
                setOnuBridge(false);
            }
        }else{
            setDatosD({...DatosD, MacOnu:'', SN:'', OnuMarca:'', MacRouter:'', RouterNSerie:'', Router:'' });
            setOnuBridge(false);
        }
    };
    
    const handleSelectSnOnu = (e, value, reason)=>{ 
        if(value !== ''){
            const arrFilter = macsOntArr.filter(el=> el.SN === value);
            if(arrFilter.length > 0){
                setDatosD({...DatosD, SN:value, MacOnu:arrFilter[0].Mac, OnuMarca:arrFilter[0].Marca, MacRouter:value, RouterNSerie:'', Router:''});
                const arrFiltradoOnu = stock.filter(el=> el.Mac === value)
                if(arrFiltradoOnu.length > 0){
                    if(arrFiltradoOnu[0].Bridge)setOnuBridge(true); 
                }
            }else{
                setDatosD({...DatosD, MacOnu:'', SN:'', OnuMarca:'', MacRouter:value, RouterNSerie:'', Router:''});
                setOnuBridge(false);
            }
        }else{
            setDatosD({...DatosD, MacOnu:'', SN:'', OnuMarca:'', MacRouter:value, RouterNSerie:'', Router:''});
            setOnuBridge(false);
        }
    };

    const handleChangeAutomatic = ()=>{
        const zonaSplit = zonaSelected.Zona.split(' ');
        const idM = `intercomy${zonaSplit[0].toString().charAt(0).toLowerCase()}${zonaSplit.length > 1 ? zonaSplit[1].toString().charAt(0).toLowerCase() : 1 }${ Math.floor(Math.random() * 1000000)}`;
        if(getArrIdForMikrotik.includes(idM)){
            alert('ID GENERADO YA EXISTE, VUELVA A CLICKEAR EL CHECK');
        }else{
            setDatosD({...DatosD, idForMikrotik:idM, UserPPOE:idM})
        }      
    };

    const handleAddressIp = ({target})=>{ 
        const elementoIp = getArrIpService.filter(el=> el.IP.toString() === target.value.toString())[0];
        if(isUnify){
            if(zonaSelected.sysintercom){
                setDatosD({...DatosD, AddressIp:target.value, idFromMikrotik:elementoIp.idFromMikrotik, idFromMikrotikSimple:elementoIp.idFromMikrotikSimple});
            }else{
                setDatosD({...DatosD, AddressIp:target.value, idFromMikrotik:elementoIp.idFromMikrotik });
            }
        }else{ 
            if(elementoIp.Status === 'DISPONIBLE' ){
                const arrIp = [...getArrIpService];
                const arrNew = arrIp.map(el=>{
                    if(el.IP === target.value){
                        const objeto = {};
                        objeto.idForMikrotik = DatosD.idForMikrotik;
                        objeto.Status = 'NO DISPONIBLE';
                        objeto.IP = target.value;
                        return objeto;
                    }else{
                        if(DatosD.AddressIp !== ''){
                            if(el.IP === DatosD.AddressIp){
                                const objeto2 = {};
                                objeto2.Status = 'DISPONIBLE';
                                objeto2.IP = DatosD.AddressIp;
                                return objeto2;
                            }else{
                                return el
                            }
                        }else{
                            return el
                        }
                    }
                });
                setArrIpService(arrNew);
                setDatosD({...DatosD, AddressIp:target.value}) 
            }else{
                Swal.fire({
                    title:'IP NO DISPONIBLE',
                    icon:'error',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                })
            }
        }
        
    };

    const handleSelectSubnet = (e, value, reason)=>{
        if(reason === 'select-option'){
            const elSubnet = zonaSelected.Subnet.filter(el=>el.Red === value)[0];  
            setDatosD({...DatosD, Red:value, Mascara:elSubnet.Mascara}); 
            const arr = [];
            for(const x in getArrIp){
                let redIp = getArrIp[x].IP.split('.');
                let red = `${redIp[0].toString()}.${redIp[1].toString()}.${redIp[2].toString()}.0`
                if(red === value) arr.push(getArrIp[x]);
            };
            setArrIpService(arr);
        }else{
            if(isUnify){
                setDatosD({...DatosD, Red:'', Mascara:'', AddresIp:'', idFromMikrotik:'', idFromMikrotikSimple:''}); 
                setArrIpService([]);
            }else{
                setDatosD({...DatosD, Red:'', Mascara:'', AddresIp:''}); 
                setArrIpService([]);
            }
        }
        
    };

    const handleAddressIpIptv = ({target})=>{ 
        const elementoIp = getArrIpServiceIptv.filter(el=> el.IP.toString() === target.value.toString())[0];
        if(elementoIp.Status === 'DISPONIBLE' ){
            const arrIp = [...getArrIpServiceIptv];
            const arrNew = arrIp.map(el=>{
                if(el.IP === target.value){
                    const objeto = {};
                    objeto.idForMikrotik = DatosD.idForMikrotik;
                    objeto.Status = 'NO DISPONIBLE';
                    objeto.IP = target.value;
                    return objeto;
                }else{
                    if(DatosD.AddressIp !== ''){
                        if(el.IP === DatosD.AddressIp){
                            const objeto2 = {};
                            objeto2.Status = 'DISPONIBLE';
                            objeto2.IP = DatosD.AddressIp;
                            return objeto2;
                        }else{
                            return el
                        }
                    }else{
                        return el
                    }
                }
            });
            setArrIpServiceIptv(arrNew);
            setDatosD({...DatosD, AddressIpIptv:target.value}) 
        }else{
            Swal.fire({
                title:'IP NO DISPONIBLE',
                icon:'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonColor:'#005596',
                toast:true,
            })
        }
        
    };

    const handleSelectSubnetIptv = (e, value, reason)=>{
        if(reason === 'select-option'){
            const elSubnet = zonaSelected.SubnetIptv.filter(el=>el.Red === value)[0];  
            setDatosD({...DatosD, RedIptv:value, MascaraIptv:elSubnet.Mascara}); 
            const arr = [];
            for(const x in getArrIpIptv){
                let redIp = getArrIpIptv[x].IP.split('.');
                let red = `${redIp[0].toString()}.${redIp[1].toString()}.${redIp[2].toString()}.0`
                if(red === value) arr.push(getArrIpIptv[x]);
            };
            setArrIpServiceIptv(arr);
        }else{
            setDatosD({...DatosD, RedIptv:'', MascaraIptv:''}); 
            setArrIpServiceIptv([]);
        }
        
    };

    const handleOpenPhoto = ()=>{ setOpenPhoto(true) };

    const handleClosePhoto = ()=>{ setOpenPhoto(false) };

    const handleUpdatePhoto = useCallback((info)=>{ setArrPhotos(info); },[]);

    const handleDeletePhoto = useCallback((info)=>{ setArrPhotos((arrPhotos)=> arrPhotos.filter(el=>el.id !== info.id)); },[]);

    const handleAddPhoto = ()=>{
        if(DatosD.idForMikrotik === ''){
            Swal.fire({
                title:'ERROR',
                icon:'error',
                text:'Primero debe asignar un idForMikrotik',
                width:600,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonColor:'#005596',
                confirmButtonText:'OK',
                toast:true
            })
        }else{ 
            const arr = [...getArrPhotos];
            const objeto = {};
            objeto.src = '';
            objeto.id = `photo_${uuidv4()}`;
            objeto.idForMikrotik = DatosD.idForMikrotik;
            arr.push(objeto);
            setArrPhotos(arr);
        }
    };

    const handleCoordenadas = ()=>{
        var options = {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        };

        function success(pos) {
            var crd = pos.coords;    
            //setCoordenadas({Latitud:crd.latitude, Longitud:crd.longitude});  
            setCoord(`${crd.latitude}, ${crd.longitude}`);  
            //setFormulario({...formulario, Latitud:crd.latitude, Longitud:crd.longitude});
        };
          
        function error(err) {
            console.warn('ERROR(' + err.code + '): ' + err.message);
        };

        navigator.geolocation.getCurrentPosition(success, error, options);
    };

    const handleIVA = ({target})=>{ setDatosD({...DatosD, IVA:target.checked}) };

    const handleCorteAutomatico = (checked)=>{ setDatosD({...DatosD, CorteAutomatico:checked})};

    const handleGenerarPass = ()=>{
        const passNew = GenerarPass();
        setDatosD({...DatosD, PassPPOE:passNew });
    };

    const copyToClipBoardUser = ()=>{  
        copy(DatosD.UserPPOE) 
        enqueueSnackbar('Copiado', {variant:'success'});
    };

    const copyToClipBoardPass = ()=>{  
        copy(DatosD.PassPPOE) 
        enqueueSnackbar('Copiado', {variant:'success'});
    };

    const handleInfoBackup = ()=>{
        Swal.fire({
            title:'DESEA VOLVER A CARGAR LA INFORMACION ORIGINAL?',
            icon:'info',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonColor:'#005596',
            width:600,
            confirmButtonText:'SI',
            denyButtonText:'NO'
        }).then((result)=>{
            if(result.isConfirmed){
                setDatosD(getInfoBackup);
                if(getInfoBackup.MacOnu){
                    if(getInfoBackup.MacOnu !== '' && getInfoBackup.MacOnu !== undefined && getInfoBackup.MacOnu !== null  && getInfoBackup.MacOnu !== ' '){
                        const arrFiltradoOnu = stock.filter(el=> el.Mac === getInfoBackup.MacOnu);
                        if(arrFiltradoOnu.length > 0){
                            if(arrFiltradoOnu[0].Bridge){
                                setOnuBridge(true);
                            }
                        }
                    }
                }
            }
        })
    };

    const handleSearchOnu = ()=>{
        setSearchingOnu(true);
        const objeto = {};
            objeto.SN = DatosD.SN;
            objeto.OLTIP = zonaSelected.OLTIP;
            objeto.OLTPORT = zonaSelected.OLTPORT;
            objeto.Usuario = zonaSelected.Usuario;
            objeto.Password = zonaSelected.Password;
        fetch('/api/SearchOnu',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            try{
                const dataSn = result.split('sn');
                if(dataSn.length > 0){
                    const infoSn = dataSn[1].toString().split('-')[0];
                    Swal.fire({
                        title:infoSn,
                        icon:'success',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonColor:'#005596',
                        toast:true,
                    }); 
                    setTimeout(()=>{
                        setSearchingOnu(false);
                    },500)
                }else{
                    Swal.fire({
                        title:'NO ESTA REGISTRADA ESTA ONU',
                        icon:'error',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonColor:'#005596',
                        toast:true,
                    })
                    setTimeout(()=>{
                        setSearchingOnu(false);
                    },500)
                }
            }catch(err){
                Swal.fire({
                    title:'NO ESTA REGISTRADA ESTA ONU',
                    icon:'error',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                })
                    setTimeout(()=>{
                        setSearchingOnu(false);
                    },500)
            }
            
        });
    };

    const handleSearchPPOE = ()=>{
        setSearchingPPOE(true);
        const objeto = {};
            objeto.idForMikrotik = DatosD.idForMikrotik;
            objeto.InfoZona = {...zonaSelected};
        fetch('/api/SearchActivePPOE',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                Swal.fire({
                    title:result.message,
                    icon:'success',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                });
                setTimeout(()=>{
                    setSearchingPPOE(false);
                },500)
            }else{
                Swal.fire({
                    title:result.status,
                    icon:'error',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                })
                setTimeout(()=>{
                    setSearchingPPOE(false);
                },500)
            }  
        }); 
    };

    const handleShowWifiInformation= ()=>{
        setShowWifiInfo(true);
        const objeto = {};
        objeto.IPCLIENTE = DatosD.AddressIp;
        objeto.Onu = DatosD.Onu;
        fetch('/api/ShowWifiInformation',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            // console.log(result.message)
            if(result.message){
                Swal.fire({
                    title:result.message,
                    icon:'success',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                });
                setTimeout(()=>{
                    setShowWifiInfo(false);
                },500)
            }else{
                Swal.fire({
                    title:result.status,
                    icon:'error',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                })
                setTimeout(()=>{
                    setShowWifiInfo(false);
                },500)
            }  
        }); 
    };

    const handleShowWifiAssociate = ()=>{
        setShowWifiAssociate(true);
        const objeto = {};
        objeto.IPCLIENTE = DatosD.AddressIp;
        objeto.Onu = DatosD.Onu;
        fetch('/api/ShowWifiAssociate',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            // console.log(result.message)
            if(result.message){
                Swal.fire({
                    title:result.message,
                    icon:'success',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                });
                setTimeout(()=>{
                    setShowWifiAssociate(false);
                },500)
            }else{
                Swal.fire({
                    title:result.status,
                    icon:'error',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                })
                setTimeout(()=>{
                    setShowWifiAssociate(false);
                },500)
            }  
        }); 
    };

    const handleShowOpticInformacion = ()=>{
        setSearchingOptic(true);
        const objeto = {};
        objeto.IPCLIENTE = DatosD.AddressIp;
        objeto.OnuMarca = DatosD.OnuMarca;
        objeto.Onu = DatosD.Onu;
        fetch('/api/ShowOpticInformation',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                Swal.fire({
                    title:`${result.message}${DatosD.OnuMarca === 'HSGQ' ? ' dBm' : ''}`,
                    icon:'success',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                });
                setTimeout(()=>{
                    setSearchingOptic(false);
                },500)
            }else{
                Swal.fire({
                    title:result.status,
                    icon:'error',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                })
                setTimeout(()=>{
                    setSearchingOptic(false);
                },500)
            } 
            
        }); 
    };

    const handleShowMacOnu = async ()=>{
        setSearchingMacOnu(true);
        const { AddressIp, OnuMarca, Onu } = DatosD;
        const getInfo_ = await handleShowMacOnuInformation({AddressIp, OnuMarca, Onu});
        // console.log(getInfo_)
        if(getInfo_.message){
            const elMacOnuGet_ = getInfo_.message === 'NO APLICA' ? getInfo_.message : getInfo_.message.toString().split('\n\nsuccess!\n>')[0].toString().split('lan mac = ')[1].toString();
            Swal.fire({
                title:elMacOnuGet_,
                icon:'success',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonColor:'#005596',
                toast:true,
            });
            setTimeout(()=>{
                setSearchingMacOnu(false);
            },500)
        }else{
            Swal.fire({
                title:getInfo_.status,
                icon:'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonColor:'#005596',
                toast:true,
            })
            setTimeout(()=>{
                setSearchingMacOnu(false);
            },500)
        } 
    };

    const handleOnWifi = ()=>{
        setOnWifi(true);
        const objeto = {};
        objeto.IPCLIENTE = DatosD.AddressIp;
        objeto.Onu = DatosD.Onu;
        fetch('/api/HuaweiOnWifi',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar(result.message, {variant:'success'});
                setTimeout(()=>{
                    setOnWifi(false);
                },500)
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
                setTimeout(()=>{
                    setOnWifi(false);
                },500)
            }            
        }); 
    };

    const handleOffWifi = ()=>{
        setOffWifi(true);
        const objeto = {};
        objeto.IPCLIENTE = DatosD.AddressIp;
        objeto.Onu = DatosD.Onu;
        fetch('/api/HuaweiOffWifi',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar(result.message, {variant:'success'});
                setTimeout(()=>{
                    setOffWifi(false);
                },500)
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
                setTimeout(()=>{
                    setOffWifi(false);
                },500)
            }           
        }); 
    };

    const handleHiddenWifi = ()=>{
        setHiddenWifi(true);
        const objeto = {};
        objeto.IPCLIENTE = DatosD.AddresIp;
        objeto.Onu = DatosD.Onu;
        fetch('/api/HuaweiHiddenWifi',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar(result.message, {variant:'success'});
                setTimeout(()=>{
                    setHiddenWifi(false);
                },500)
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
                setTimeout(()=>{
                    setHiddenWifi(false);
                },500)
            } 
        }); 
    };

    const handleNoHiddenWifi = ()=>{
        setNoHiddenWifi(true);
        const objeto = {};
        objeto.IPCLIENTE = DatosD.AddresIp;
        objeto.Onu = DatosD.Onu;
        fetch('/api/HuaweiNoHiddenWifi',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar(result.message, {variant:'success'});
                setTimeout(()=>{
                    setNoHiddenWifi(false);
                },500)
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
                setTimeout(()=>{
                    setNoHiddenWifi(false);
                },500)
            } 
        }); 
    };

    const handleClickChangeName = ()=>{ 
        setNameChange(true);
        const objeto = {};
        objeto.IPCLIENTE = DatosD.AddressIp;
        objeto.NAMEWIFI = getNameWifi;
        objeto.idCliente = dataCliente._id;
        objeto.idServicio = DatosD._id;
        objeto.OnuMarca = DatosD.OnuMarca;
        objeto.banda = is5G ? '5G' : '2.4G';
        objeto.Onu = DatosD.Onu;
        fetch('/api/HuaweiChangeNameWifi',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar(result.message, {variant:'success'});
                setDatosD({...DatosD, NameWifi:getNameWifi});
                setTimeout(()=>{
                    setNameChange(false);
                },500)
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
                setTimeout(()=>{
                    setNameChange(false);
                },500)
            } 
        }); 
    };

    const handleClickChangePass = ()=>{ 
        setPassChange(true);
        const objeto = {};
        objeto.IPCLIENTE = DatosD.AddressIp;
        objeto.PASSWIFI = getPassWifi;
        objeto.idCliente = dataCliente._id;
        objeto.idServicio = DatosD._id;
        objeto.OnuMarca = DatosD.OnuMarca;
        objeto.banda = is5G ? '5G' : '2.4G';
        fetch('/api/HuaweiChangePassWifi',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar(result.message, {variant:'success'});
                setDatosD({...DatosD, PassWifi:getPassWifi});
                setTimeout(()=>{
                    setPassChange(false);
                },500)
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
                setTimeout(()=>{
                    setPassChange(false);
                },500)
            } 
        }); 
    };

    const handleNameWifi = ({target})=>{ setNameWifi(target.value) };

    const handlePassWifi = ({target})=>{ setPassWifi(target.value) };

    const handleRebootOnt = ()=>{
        setRebootOnt(true);
        const objeto = {};
        objeto.IPCLIENTE = DatosD.AddressIp;
        objeto.OnuMarca = DatosD.OnuMarca;
        objeto.Onu = DatosD.Onu;
        fetch('/api/HuaweiRebootOnt',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar(result.message, {variant:'success'});
                setTimeout(()=>{
                    setRebootOnt(false);
                },500)
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
                setTimeout(()=>{
                    setRebootOnt(false);
                },500)
            } 
        });
    };

    const handleSubNetWatch = async ({target})=>{
        if(target.checked){
            const isActiveN = await handleNetWatch({
                AddressIp:DatosD.AddressIp, 
                ActiveNetWatch:true, 
                InfoZona:zonaSelected,
                idForMikrotik:data.idForMikrotik,
                Nombres:dataCliente.Nombres,
                idServicio:DatosD._id,
                idCliente:dataCliente._id,
            });

            if(isActiveN.isCreate){
                setDatosD({...DatosD, idNetWatch:isActiveN.idNetWatch, ActiveNetWatch:true})
                enqueueSnackbar('CLIENTE VIGILADO', {variant:'success'});
            }else{
                enqueueSnackbar(isActiveN.reason, {variant:'error'});
            }

            
            
        }else{
            const isActiveN = await handleNetWatch({
                ActiveNetWatch:false, 
                InfoZona:zonaSelected,
                idNetWatch:DatosD.idNetWatch,
                idServicio:DatosD._id,
                idCliente:dataCliente._id,
            });
            
            if(isActiveN.isCreate){
                enqueueSnackbar('CLIENTE SIN VIGILAR', {variant:'success'});
                setDatosD({...DatosD, idNetWatch:'', ActiveNetWatch:false})
            }else{
                enqueueSnackbar(isActiveN.reason, {variant:'error'});
            }
        }
        
    };

    const copyAddressIp = ()=>{
        copy(DatosD.AddressIp);
        enqueueSnackbar('Copiado', {variant:'success'});
    };

    const handleBy5G = (checked)=>{ set5G(checked) };

    const handleBlurCoord = ({target})=>{
        if(target.value !== ''){
            if (!target.value.match(/^[-]?\d+[.]?\d*, [-]?\d+[.]?\d*$/)) {
                alert('COORDENADAS ERRONEAS')
            }
        }
    };

    const handlePingOnu = ()=>{
        setSearchingPingOnu(true)
        fetch('/api/pingOnu',{
            method:'POST',
            body: JSON.stringify({AddressIp:DatosD.AddressIp}),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                Swal.fire({
                    title:result.message,
                    icon:'success',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                });
                setTimeout(()=>{
                    setSearchingPingOnu(false);
                },500)
            }else{
                Swal.fire({
                    title:result.status,
                    icon:'error',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                })
                setTimeout(()=>{
                    setSearchingPingOnu(false);
                },500)
            } 
        }); 
    };

    const handleUnify = ({target})=>{
        if(data.isNew){
            setUnify(target.checked);
        }else{
            if(isUnify){
                setUnify(false);
                setDatosD({...DatosD, idFromMikrotik:getInfoBackup.idFromMikrotik, AddressIp:getInfoBackup.AddressIp});
            }else{
                setUnify(target.checked);
            }
        }
    };

    const handleServActive = (checked)=>{
        setOfflineServ(true)
        fetch('/api/clientes/servicios/changeStatusMk',{
            method:'POST',
            body: JSON.stringify({
                serviceSelected:DatosD,
                InfoZona:zonaSelected,
                Status:checked,
            }),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                Swal.fire({
                    title:'SERVICIO ACTUALIZADO',
                    icon:'success',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                });
                setServActive(checked);
                setTimeout(()=>{
                    setOfflineServ(false);
                },500)
            }else{
                Swal.fire({
                    title:result.status,
                    icon:'error',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                })
                setTimeout(()=>{
                    setOfflineServ(false);
                },500)
            } 
        }); 
    };

    const handleOTT = (checked)=>{
        setOttServ(true)
        fetch('/api/clientes/servicios/changeStatusOtt',{
            method:'POST',
            body: JSON.stringify({
                Nombres:dataCliente.Nombres,
                serviceSelected:DatosD,
                InfoZona:zonaSelected,
                Status:checked,
            }),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                Swal.fire({
                    title:'OTT ACTUALIZADO',
                    icon:'success',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                });
                setOttActive(checked);
                setTimeout(()=>{
                    setOttServ(false);
                },500)
            }else{
                Swal.fire({
                    title:result.status,
                    icon:'error',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                })
                setTimeout(()=>{
                    setOttServ(false);
                },500)
            } 
        }); 
    };

    const handleMesArcotel = (e, value, reason)=>{
        if(reason === 'select-option'){
            setDatosD({...DatosD, MesArcotel:value });
        }else{
            setDatosD({...DatosD, MesArcotel:'' })
        }
    };


    return(
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
            <Dialog
                open={openPhoto}
                onClose={handleClosePhoto}
                fullWidth
                maxWidth={'sm'}
                style={{padding:0}}
            >
                <DialogTitle id="customized-dialog-title" onClose={handleClosePhoto}>
                    <Grid container justifyContent='center' spacing={1}>
                        <Grid item style={{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center'}}>
                            <Chip color='secondary' label='FOTOS REFERENCIA' style={{fontWeight:'bolder'}}/>
                        </Grid>
                        <Grid item style={{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center'}}>
                            <Tooltip title='ADD PHOTO' arrow placement='right'>
                                <span>
                                <IconButton size='medium' onClick={handleAddPhoto} >
                                    <AddCircleIcon color='primary'/>
                                </IconButton>
                                </span>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent style={{margin:0, padding:5, overflowX:'hidden'}}>
                    <Divider />
                    <Paper variant="outlined" square style={{padding:10, width:'100%'}} >
                    <Grid container justifyContent='center' spacing={2}>                   
                    {
                        getArrPhotos.map((infoPhoto, index)=> 
                            <Grid item key={`tiptraphoto_${index}`}>
                                <UploadElementYounet
                                    classes={classes}
                                    handleUpdatePhoto={handleUpdatePhoto}
                                    info={infoPhoto}
                                    handleDeletePhoto={handleDeletePhoto}
                                    idForMikrotik={DatosD.idForMikrotik}
                                    idServicio={DatosD._id}
                                    idCliente={dataCliente._id}
                                    getArrPhotos={getArrPhotos}
                                    enqueueSnackbar={enqueueSnackbar}
                                />
                            </Grid>
                        )
                    }
                    </Grid>
                     </Paper>
                    
                </DialogContent>
            </Dialog> 
            <ModalAntd title="CONFIGURACIONES WIFI" visible={openConfWifi} onCancel={handleCloseConfWifi} okButtonProps={{disabled:true, type:'ghost'}}>
                <Paper variant="outlined" square style={{padding:10, width:'100%'}} >
                    <Grid container justifyContent='space-between' spacing={2}> 
                        <Grid item xs={12}>
                            <Grid container justifyContent='space-around' spacing={1}>                   
                                <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                    <TooltipAntd title="ON WIFI" color='purple' placement='right'>
                                        <Popconfirm
                                            title="DESEA ENCENDER LA RED WIFI?"
                                            onConfirm={handleOnWifi}
                                            okText="SI"
                                            cancelText="NO"
                                        >
                                            <ButtonAntd shape='circle' type="primary" icon={isOnWifi ? <LoadingOutlinedIcon /> : <PoweroffOutlinedIcon />} size='large' />
                                        </Popconfirm>
                                    </TooltipAntd>
                                </Grid>
                                <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                    <TooltipAntd title="OFF WIFI" color='purple' placement='left'>
                                        <Popconfirm
                                            title="DESEA APAGAR LA RED WIFI?"
                                            onConfirm={handleOffWifi}
                                            okText="SI"
                                            cancelText="NO"
                                        >
                                            <ButtonAntd shape='circle' type="danger" icon={isOffWifi ? <LoadingOutlinedIcon /> : <PoweroffOutlinedIcon />} size='large' />
                                        </Popconfirm>
                                    </TooltipAntd>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container justifyContent='space-around' spacing={1}>                   
                                <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                    <TooltipAntd title="VISIBLE WIFI" color='purple' placement='right'>
                                        <Popconfirm
                                            title="DESEA PONER VISIBLE LA RED WIFI?"
                                            onConfirm={handleNoHiddenWifi}
                                            okText="SI"
                                            cancelText="NO"
                                        >
                                            <ButtonAntd shape='circle' type="primary" icon={isNoHiddenWifi ? <LoadingOutlinedIcon /> : <EyeOutlinedIcon />} size='large'/>
                                        </Popconfirm>
                                    </TooltipAntd>
                                </Grid>
                                <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                    <TooltipAntd title="OCULTAR WIFI" color='purple' placement='left' >
                                        <Popconfirm
                                            title="DESEA OCULTAR LA RED WIFI?"
                                            onConfirm={handleHiddenWifi}
                                            okText="SI"
                                            cancelText="NO"
                                        >
                                            <ButtonAntd shape='circle' type="ghost" icon={isHiddenWifi ? <LoadingOutlinedIcon /> : <EyeInvisibleOutlinedIcon />} size='large' />
                                        </Popconfirm>
                                    </TooltipAntd>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container justifyContent='space-around' spacing={1}>                   
                                <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}} xs={12}>
                                    <TextField 
                                        id='nameWifiHuawei'
                                        fullWidth
                                        label='NOMBRE WIFI'
                                        value={getNameWifi || ''}
                                        onChange={handleNameWifi}
                                        variant='outlined'
                                        size='large'
                                        margin='dense'
                                    />
                                </Grid>
                                <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}} xs={4}>
                                    <SwitchAntd checkedChildren="5G" unCheckedChildren="2.4G" checked={is5G} onChange={handleBy5G} />
                                </Grid>
                                <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}} xs={8}>
                                    <Popconfirm
                                        title="DESEA CAMBIAR EL NOMBRE DE LA RED WIFI?"
                                        onConfirm={handleClickChangeName}
                                        okText="SI"
                                        cancelText="NO"
                                    >
                                        <ButtonAntd type="primary"  size='large' icon={isChangeName ? <LoadingOutlinedIcon/> :<SyncOutlinedIcon/>} >
                                            CAMBIAR NOMBRE
                                        </ButtonAntd>
                                    </Popconfirm>
                                    
                                </Grid>
                                
                                <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}} xs={12}>
                                    <TextField 
                                        id='passWifiHuawei'
                                        fullWidth
                                        label='PASS WIFI'
                                        value={getPassWifi || ''}
                                        onChange={handlePassWifi}
                                        variant='outlined'
                                        size='large'
                                        margin='dense'
                                        placeholder='MINIMO 8 DIGITOS'
                                    />
                                </Grid>
                                <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}} xs={4}>
                                    <SwitchAntd checkedChildren="5G" unCheckedChildren="2.4G" checked={is5G} onChange={handleBy5G} />
                                </Grid>
                                <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}} xs={8}>
                                    <Popconfirm
                                        title="DESEA CAMBIAR EL PASS DE LA RED WIFI?"
                                        onConfirm={handleClickChangePass}
                                        okText="SI"
                                        cancelText="NO"
                                    >
                                        <ButtonAntd type="primary"  size='large' icon={isChangePass ? <LoadingOutlinedIcon/> :<SyncOutlinedIcon/>} >
                                            CAMBIAR PASS
                                        </ButtonAntd>
                                    </Popconfirm>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
            </ModalAntd> 
            <Paper elevation={3} style={{padding:10}} key={`servicio${index}`}>
                <Grid container  spacing={2} justifyContent='center'>
                    <Grid item xs={12} style={{height:5}}>
                        {!isIpsCharged &&  <LinearProgress color='secondary' /> }
                    </Grid>
                    <Grid item xs={12} style={{display:'flex', flexDirection:'row', justifyContent:'center'}}>
                        <Grid container spacing={2} justifyContent='center'>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="NUMERO DE CONTRATO" color='blue' placement='left'>
                                    <Avatar style={{width:40, height:40}} >
                                        { DatosD.NumberServiceClient ? DatosD.NumberServiceClient : 0 }
                                    </Avatar>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center', height:42, alignText:'center',}}>
                                {
                                    DatosD.Status === 'Activo' ?
                                        <TooltipAntd title="SERVICIO ACTIVO" color='green'>
                                            <CheckCircleIcon style={{color:'green', marginTop:15}} fontSize='large'/>
                                        </TooltipAntd>
                                        :
                                        <TooltipAntd title="SERVICIO SUSPENDIDO" color='red'>
                                            <BlockIcon style={{color:'red', marginTop:15}} fontSize='large'/>
                                        </TooltipAntd>
                                }                                       
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="GUARDAR SERVICIO" color='purple'>
                                    <ButtonAntd type="primary" icon={isSaving ? <LoadingOutlinedIcon/> : <SaveOutlinedIcon />} size='large' onClick={handleAlertSaveServicio} style={{background:'blue'}}/>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="ELIMINAR SERVICIO" color='purple'>
                                    <ButtonAntd type="danger" icon={<DeleteOutlinedIcon />} size='large' onClick={handleDeleteServicio} disabled={authTokens.Type === 'ADMINISTRADOR' ? false : true}/>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="BACKUP" color='purple'>
                                    <ButtonAntd type="primary" icon={<ReloadOutlinedIcon />} size='large' onClick={handleInfoBackup}/>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="CONSUMO CLIENTE" color='purple'>
                                    <ButtonAntd 
                                        href={`http://${DatosD.Red.split('.')[0]}.${DatosD.Red.split('.')[1]}.${DatosD.Red.split('.')[2]}.1/graphs/${zonaSelected.ppoeList ? 'iface': 'queue'}/${zonaSelected.ppoeList ? '<pppoe-' + DatosD.UserPPOE +'>' : DatosD.idForMikrotik}/`}
                                        icon={<AreaChartOutlined />} 
                                        size='large' 
                                        style={{background:'#9CCC65', borderColor:'#8BC34A'}} 
                                        target="_blank" 
                                        type="primary" 
                                    />
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="STATUS ONT" color='purple'>
                                    <ButtonAntd type="primary" icon={isSearchingOnu ? <LoadingOutlinedIcon /> : <ApiOutlinedIcon />} size='large' onClick={handleSearchOnu}/>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="STATUS PPOE" color='purple'>
                                    <ButtonAntd type="primary" icon={isSearchingPPOE ? <LoadingOutlinedIcon/> : <SecurityScanOutlinedIcon />} size='large' onClick={handleSearchPPOE}/>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="ESTADO OPTICO" color='purple'>
                                    <ButtonAntd style={{background:'OliveDrab'}} type="primary" icon={getSearchingOptic ? <LoadingOutlinedIcon /> : <ClusterOutlinedIcon />} size='large' onClick={handleShowOpticInformacion}/>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="PING ONU" color='purple'>
                                    <ButtonAntd style={{background:'black'}} type="primary" icon={isSearchingPingOnu ? <LoadingOutlinedIcon /> : <NodeIndexOutlined />} size='large' onClick={handlePingOnu}/>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="SHOW MAC ONU" color='purple'>
                                    <ButtonAntd style={{background:'blue'}} type="primary" icon={isSearchingMacOnu ? <LoadingOutlinedIcon /> : <UngroupOutlined />} size='large' onClick={handleShowMacOnu}/>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="WIFI DETALLES" color='purple'>
                                    <ButtonAntd style={{background:'teal'}} type="primary" icon={getShowWifiInfo ? <LoadingOutlinedIcon /> : <WifiOutlinedIcon />} size='large' onClick={handleShowWifiInformation}/>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="DISP. CONECTADOS AL WIFI" color='purple'>
                                    <ButtonAntd style={{background:'green'}} type="primary" icon={getShowWifiAssociate ? <LoadingOutlinedIcon /> : <TeamOutlinedIcon />} size='large' onClick={handleShowWifiAssociate}/>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="CONF. WIFI" color='purple'>
                                    <ButtonAntd style={{background:'MediumSlateBlue'}} type="primary" icon={<SettingOutlinedIcon />} size='large' onClick={handleOpenConfWifi}/>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="REINICIAR ONT" color='purple'>
                                    <Popconfirm
                                        title="DESEA REINICIAR LA ONT?"
                                        onConfirm={handleRebootOnt}
                                        okText="SI"
                                        cancelText="NO"
                                    >
                                        <ButtonAntd shape='circle' type="primary" icon={isRebootOnt ? <LoadingOutlinedIcon /> : <PoweroffOutlinedIcon />} size='large' />
                                    </Popconfirm>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="CREAR PDF" color='purple'>
                                    <ButtonAntd type="danger" icon={<FilePdfOutlinedIcon />} size='large' onClick={handleCreatePdf}/>
                                </TooltipAntd>
                            </Grid>
                            <Grid item >
                                { isReadyPdf && 
                                    <PdfInstalacionFibra 
                                        data={ DatosD }
                                        dataCliente={ dataCliente }
                                        dataZona={ zonaSelected }
                                        getPlanes={ zonaSelected.planLocal ? zonaSelected.Planes : getPlanes }
                                        getEquiposAll={ getEquiposAll }
                                        handleClickPdf={ handleClickPdf } 
                                    />
                                }
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="EQUIPO DE ULTIMA MILLA PERMITE ACCESO TELNET?" color='purple'>
                                    <SwitchAntd 
                                        checkedChildren='ON TELNET' 
                                        onChange={(checked)=>{setDatosD({...DatosD, isTelnet:checked})}}
                                        unCheckedChildren="OFF TELNET" 
                                        checked={DatosD.isTelnet || false}
                                    />
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="CLIENTE CON VALORES A PAGAR EN $0" color='purple'>
                                    <CheckboxAntd onChange={({target})=>{setDatosD({...DatosD, isFree:target.checked})}} checked={DatosD.isFree || false}>
                                        <Chip label="FREE" color='secondary' style={{backgroundColor:'#5D6D7E'}}/>
                                    </CheckboxAntd>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="CLIENTE REGISTRADO EN LA ARCOTEL?" color='purple'>
                                    <CheckboxAntd onChange={({target})=>{setDatosD({...DatosD, isArcotel:target.checked})}} checked={DatosD.isArcotel || false}>
                                        <Chip label="ARCOTEL" color='secondary' style={{backgroundColor:'SteelBlue'}}/>
                                    </CheckboxAntd>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <CheckboxAntd onChange={handleIVA} checked={DatosD.IVA}>
                                    <Chip label="IVA" color='secondary'/>
                                </CheckboxAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <CheckboxAntd onChange={handleNotificacion} checked={isNotificacion}>
                                    <Chip label="NOTIFICACION" color='primary' />
                                </CheckboxAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <CheckboxAntd onChange={handleSubNetWatch} checked={DatosD.ActiveNetWatch}>
                                    <Chip label="NETWATCH" color='primary' style={{background:'dodgerBlue'}}/>
                                </CheckboxAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="DESEA CREAR INSTALACION?" color='purple'>
                                    <CheckboxAntd onChange={({target})=>{setCreateInstalacion(target.checked)}} checked={isCreateInstalacion}>
                                        <Chip label="INSTALACION" color='primary' style={{background:'MediumSeaGreen'}}/>
                                    </CheckboxAntd>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="DESEA CREAR FACTURAS?" color='purple'>
                                    <CheckboxAntd onChange={({target})=>{setCreateInvoice(target.checked)}} checked={isCreateInvoice} >
                                        <Chip label="FACTURA" color='primary' style={{background:'crimson'}}/>
                                    </CheckboxAntd>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="UNIFICAR" color='purple'>
                                    <CheckboxAntd onChange={handleUnify} checked={isUnify} >
                                        <Chip label="UNIFICAR" color='primary' style={{background:'#5D6D7E'}}/>
                                    </CheckboxAntd>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="ACTIVAR O SUSPENDER SERVICIO" color='red'>
                                    <SwitchAntd 
                                        checkedChildren='ONLINE' 
                                        onChange={handleServActive}
                                        unCheckedChildren="OFFLINE" 
                                        checked={isServActive || false}
                                    />
                                </TooltipAntd>
                                {isOfflineServ && <LoadingOutlinedIcon />}
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="OTT" color='green'>
                                    <SwitchAntd 
                                        checkedChildren='SI' 
                                        onChange={handleOTT}
                                        unCheckedChildren="NO" 
                                        checked={isOttActive || false}
                                    />
                                </TooltipAntd>
                                {isOttServ && <LoadingOutlinedIcon />}
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item lg={3} md={6} sm={6} xs={12} >
                        <Grid container spacing={1}>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="GENERAR ID" color='purple'>
                                    <ButtonAntd type="primary" icon={<RedoOutlinedIcon />} size='large' onClick={handleChangeAutomatic}/>
                                </TooltipAntd>
                                
                            </Grid>
                            <Grid item xs={10}>
                                <TextField 
                                    id='idForMikrotik'
                                    fullWidth
                                    label='idMikrotik'
                                    value={DatosD.idForMikrotik || ''}
                                    onChange={handleDatosIdMikrotik}
                                    variant='outlined'
                                    size='small'
                                    margin='dense'
                                    InputProps={{ 
                                        startAdornment: <WhatshotIcon/>, 
                                        endAdornment:
                                        <IconButton size='small' onClick={copyToClipBoardUser} color='primary'>
                                            <ContentCopyIcon/>
                                        </IconButton>
                                    }} 
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item lg={3} md={6} sm={6} xs={12}>
                        <TextField 
                            id='idFromMikrotik'
                            fullWidth
                            label='idFromMikrotik'
                            value={DatosD.idFromMikrotik || ''}
                            onChange={handleDatos}
                            variant='outlined'
                            size='small'
                            margin='dense'
                            InputProps={{ startAdornment: <WhatshotIcon/>  }} 
                        />
                    </Grid>
                    <Grid item lg={3} md={6} sm={6} xs={12} >
                        <TextField 
                            id='CodigoMedidor'
                            fullWidth
                            label='Codigo de Medidor'
                            value={DatosD.CodigoMedidor || ''}
                            onChange={handleDatos}
                            variant='outlined'
                            size='small'
                            margin='dense'
                            InputProps={{ startAdornment: <EmojiObjectsIcon/>  }} 
                        />
                    </Grid>
                    <Grid item lg={3} md={6} sm={6} xs={12} >
                        <Autocomplete
                            id='Plan'                                            
                            options={Planes}
                            getOptionLabel={(option)=>option.PlanComercial}
                            inputValue={DatosD.PlanComercial || ''}
                            onInputChange={handlePlanes}
                            renderInput={(params) => <TextField {...params} InputProps={{...params.InputProps, startAdornment: <SpeedIcon/>}} 
                            fullWidth label="Plan" variant="outlined" required size='small'margin='dense'
                        />}
                        />
                    </Grid>
                    <Grid item lg={3} md={6} sm={6} xs={12} >
                        <TextField 
                            id='TipoCuenta'
                            fullWidth
                            label='Tipo de Cuenta'
                            value={ DatosD.TipoCuenta || '' }
                            onChange={handleCuentasSelect}
                            variant='outlined'
                            size='small'
                            margin='dense'
                            select
                        >
                            {
                                getCuentas.map((el,index)=>                                   
                                <MenuItem value={el} key={`Cuenta_${index}_${el}`}>
                                    {el}
                                </MenuItem>
                                )
                            }
                        </TextField>
                    </Grid>
                    <Grid item lg={3} md={6} sm={6} xs={12} >
                        <TextField 
                            id='Provincia'
                            fullWidth
                            label='Provincia'
                            value={DatosD.Provincia || ''}
                            onChange={handleDatos}
                            InputProps={{ startAdornment: <PlaceIcon/> }}
                            variant='outlined'
                            margin='dense'
                            size='small'
                        />
                    </Grid>
                    <Grid item lg={2} md={6} sm={6} xs={12} >
                        <TextField 
                            id='Ciudad'
                            fullWidth
                            label='Ciudad'
                            value={DatosD.Ciudad || ''}
                            onChange={handleDatos}
                            InputProps={{ startAdornment: <PlaceIcon/> }}
                            variant='outlined'
                            margin='dense'
                            size='small'
                        />
                    </Grid>
                    <Grid item lg={2} md={6} sm={6} xs={12} >
                        <TextField 
                            id='Canton'
                            fullWidth
                            label='Canton'
                            value={DatosD.Canton || ''}
                            onChange={handleDatos}
                            InputProps={{ startAdornment: <PlaceIcon/> }}
                            variant='outlined'
                            margin='dense'
                            size='small'
                        />
                    </Grid>
                    <Grid item lg={2} md={6} sm={6} xs={12} >
                        <TextField 
                            id='Parroquia'
                            fullWidth
                            label='Parroquia'
                            value={DatosD.Parroquia || ''}
                            onChange={handleDatos}
                            InputProps={{ startAdornment: <PlaceIcon/> }}
                            variant='outlined'
                            margin='dense'
                            size='small'
                        />
                    </Grid>
                    <Grid item md={6} sm={6} xs={12} >
                        <TextField 
                            id='Direccion'
                            fullWidth
                            label='Direccion'
                            value={DatosD.Direccion || ''}
                            onChange={handleDatos}
                            InputProps={{ startAdornment: <PlaceIcon/> }}
                            variant='outlined'
                            size='small'
                            margin='dense'
                        />
                    </Grid> 
                    <Grid item md={4} sm={6} xs={12} >
                        <TextField 
                            id='Referencia'
                            fullWidth
                            label='Referencia'
                            value={DatosD.Referencia || ''}
                            onChange={handleDatos}
                            variant='outlined'
                            margin='dense'
                            InputProps={{
                                startAdornment: <PlaceIcon/>,
                                endAdornment: 
                                <IconButton aria-label="search" onClick={handleOpenPhoto} size='small'>
                                    <PhotoIcon color='primary' />
                                </IconButton>
                            }}
                            size='small'
                        />
                    </Grid>  
                    <Grid item md={2} sm={6} xs={12} >
                        <Autocomplete
                            id='MesArcotel'       
                            disabled={!DatosD.isArcotel}                                     
                            options={onlyMeses}
                            value={DatosD.MesArcotel || ''}
                            onChange={handleMesArcotel}
                            renderInput={(params) => <TextField {...params} InputProps={{...params.InputProps,
                                startAdornment: <EventIcon/>,
                            }} fullWidth label="Mes Arcotel" variant="outlined" required size='small' margin='dense'/>}
                        />
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={6} xs={12} >
                        <TextField 
                            id='Coordenadas'
                            fullWidth
                            label='Coordenadas'
                            value={getCoord || ''}
                            onChange={({target})=>{
                                setCoord(target.value)
                            }}
                            onBlur={handleBlurCoord}
                            variant='outlined'
                            InputProps={{
                                endAdornment: 
                                <IconButton aria-label="search" onClick={handleCoordenadas} size='small'>
                                    <GpsFixedIcon color='primary' />
                                </IconButton>
                            }}
                            size='small'
                            margin='dense'
                        />
                    </Grid>
                    {
                        zonaSelected.AddClientMikrotik ?
                        <React.Fragment>
                            <Grid item xl={4} lg={4} md={6} sm={6} xs={12} >
                                <Autocomplete
                                    id='Subnet'                                            
                                    options={zonaSelected.Subnet.map(el=>el.Red)}
                                    value={DatosD.Red || ''}
                                    onChange={handleSelectSubnet}
                                    renderInput={(params) => <TextField {...params} margin='dense' fullWidth label="Subnet" variant="outlined" size='small'/>}
                                />
                            </Grid>
                            <Grid item xl={4} lg={4} md={6} sm={6} xs={12} >
                                <Grid container spacing={1}>
                                    <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                        <TooltipAntd title="ACCESO ONT" color='purple'>
                                            <IconButton color="primary"  size='medium'  target="_blank" href={`http://${DatosD.AddressIp}`}>
                                                <ChromeOutlinedIcon />
                                            </IconButton>
                                        </TooltipAntd>
                                        
                                    </Grid>
                                    <Grid item xs={8}>
                                        <TextField 
                                            id='AddressIp'
                                            fullWidth
                                            label='IP'
                                            value={DatosD.AddressIp || ''}
                                            InputProps={{ startAdornment:<DnsIcon/> }}
                                            onChange={handleAddressIp}
                                            variant='outlined'
                                            size='small'
                                            margin='dense'
                                            select
                                        >
                                            {
                                                getArrIpService.map((el, index)=>{
                                                    if(el.Status === 'DISPONIBLE'){
                                                        return(
                                                            <MenuItem value={el.IP.toString()} style={{color:'green'}} key={`IP_Address_${index}`}>
                                                                {el.IP.toString()}
                                                            </MenuItem>
                                                        )
                                                    }else{
                                                        return(
                                                            <MenuItem value={el.IP.toString()} style={{color:el.Status === 'NO DISPONIBLE' ? 'red': 'orange'}} key={`IP_Address_${index}`} >
                                                                { `${el.IP.toString()} ${el.idForMikrotik === null ? '' : el.idForMikrotik}` }
                                                            </MenuItem>
                                                        )
                                                    }
                                                })
                                            }
                                        </TextField>
                                    </Grid>
                                    <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                        <IconButton color="primary"  size='medium'  onClick={copyAddressIp}>
                                            <ContentCopyIcon />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </React.Fragment>:
                        <Grid item xl={4} lg={4} md={6} sm={6} xs={12} >
                            <TextField 
                                id='AddressIp'
                                fullWidth
                                label='IP'
                                value={DatosD.AddressIp || ''}
                                InputProps={{ startAdornment:<DnsIcon/> }}
                                onChange={handleDatos}
                                variant='outlined'
                                size='small'
                                margin='dense'
                            />
                        </Grid>
                    }     
                    {
                        zonaSelected.isIptv ?
                        <React.Fragment>
                            <Grid item xl={4} lg={4} md={6} sm={6} xs={12} >
                                <Autocomplete
                                    id='SubnetIptv'                                            
                                    options={zonaSelected.SubnetIptv.map(el=>el.Red)}
                                    value={DatosD.RedIptv || ''}
                                    onChange={handleSelectSubnetIptv}
                                    renderInput={(params) => <TextField {...params} margin='dense' fullWidth label="SubnetIptv" variant="outlined" size='small'/>}
                                />
                            </Grid>
                            <Grid item xl={4} lg={4} md={6} sm={6} xs={12} >
                                        <TextField 
                                            id='AddressIpIptv'
                                            fullWidth
                                            label='IP_IPTV'
                                            value={DatosD.AddressIpIptv || ''}
                                            InputProps={{ startAdornment:<DnsIcon/> }}
                                            onChange={handleAddressIpIptv}
                                            variant='outlined'
                                            size='small'
                                            margin='dense'
                                            select
                                        >
                                            {
                                                getArrIpServiceIptv.map((el, index)=>{
                                                    if(el.Status === 'DISPONIBLE'){
                                                        return(
                                                            <MenuItem value={el.IP.toString()} style={{color:'green'}} key={`IP_Address_${index}`}>
                                                                {el.IP.toString()}
                                                            </MenuItem>
                                                        )
                                                    }else{
                                                        return(
                                                            <MenuItem value={el.IP.toString()} style={{color:el.Status === 'NO DISPONIBLE' ? 'red': 'orange'}} key={`IP_Address_${index}`} >
                                                                { `${el.IP.toString()} ${el.idForMikrotik === null ? '' : el.idForMikrotik}` }
                                                            </MenuItem>
                                                        )
                                                    }
                                                })
                                            }
                                        </TextField>
                            </Grid>
                        </React.Fragment>:null
                    }   
                    <Grid item xl={4} lg={2} md={6} sm={6} xs={12} >
                        <TextField 
                            id='TecnicoAsignado'
                            fullWidth
                            label='Tecnico'
                            value={DatosD.TecnicoAsignado || ''}
                            onChange={handleDatosSelect}
                            variant='outlined'
                            size='small'
                            margin='dense'
                            select
                        >
                            {
                                getTecnicos.map(el=> el.NombresReducidos).map((el,index)=>                                   
                                <MenuItem value={el} key={`Tecnicos_${index}_${el}`}>
                                    {el}
                                </MenuItem>
                                )
                            }
                        </TextField>
                    </Grid>
                    <Grid item xl={4} lg={3} md={6} sm={6} xs={12} >
                        <Autocomplete
                            id='Onu'                                            
                            options={onlyOnts}
                            value={DatosD.Onu || ''}
                            onChange={handleOnus}
                            renderInput={(params) => <TextField {...params} InputProps={{...params.InputProps,
                                startAdornment: <RouterIcon/>,
                            }} fullWidth label="ONU" variant="outlined" required size='small' margin='dense'/>}
                        />
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={6} xs={12} >
                        <Autocomplete
                            id='MacOnu'                                            
                            options={macsOntArr}
                            inputValue={DatosD.MacOnu || ''}
                            onInputChange={handleSelectMacOnu}
                            getOptionLabel={(option) => option.Mac}
                            renderOption={(option) => (
                                <span style={{color: option.Status === 'Disponible' ? 'green' : option.Status === 'No Disponible' ? 'red' : 'orange'}}>{option.Mac}</span>
                            )}
                            renderInput={(params) => <TextField {...params} InputProps={{...params.InputProps, startAdornment: <RouterIcon/>,}} margin='dense' fullWidth label="Mac Onu" variant="outlined" required size='small'/>}
                        />
                    </Grid>
                    <Grid item xl={4} lg={3} md={6} sm={6} xs={12} >
                        <Autocomplete
                            id='SN'                                            
                            options={snOntArr}
                            inputValue={DatosD.SN || ''}
                            onInputChange={handleSelectSnOnu}
                            getOptionLabel={(option) => option.SN}
                            renderOption={(option) => (
                                <span style={{color: option.Status === 'Disponible' ? 'green' : option.Status === 'No Disponible' ? 'red' : 'orange'}}>{option.SN}</span>
                            )}
                            renderInput={(params) => <TextField {...params} InputProps={{...params.InputProps, startAdornment: <RouterIcon/>,}} margin='dense' fullWidth label="SN" variant="outlined" required size='small'/>}
                        />
                    </Grid>
                    {
                        zonaSelected.ppoeList &&
                        <React.Fragment>
                            <Grid item xl={4} lg={4} md={6} sm={6} xs={12} >
                                <TextField 
                                    id='UserPPOE'
                                    fullWidth
                                    label='UserPPOE'
                                    value={DatosD.UserPPOE || ''}
                                    InputProps={{
                                        startAdornment:<DnsIcon/>,
                                        endAdornment:
                                        <IconButton size='small' onClick={copyToClipBoardUser} color='primary'>
                                            <ContentCopyIcon/>
                                        </IconButton>
                                    }}
                                    onChange={handleDatosIdMikrotik}
                                    variant='outlined'
                                    size='small'
                                    margin='dense'
                                />
                            </Grid>
                            <Grid item xl={4} lg={4} md={6} sm={6} xs={12}  >
                                <Grid container spacing={2}>
                                    <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                        <TooltipAntd title="GENERAR PASS" color='purple'>
                                            <ButtonAntd type="primary" icon={<LockOutlined />} size='large' onClick={handleGenerarPass}/>
                                        </TooltipAntd>
                                    </Grid>
                                    <Grid item xs={10}>
                                        <TextField 
                                            id='PassPPOE'
                                            fullWidth
                                            label='PassPPOE'
                                            value={DatosD.PassPPOE || ''}
                                            InputProps={{
                                                startAdornment:<DnsIcon/>,
                                                endAdornment:
                                                <IconButton size='small' onClick={copyToClipBoardPass} color='primary'>
                                                    <ContentCopyIcon/>
                                                </IconButton>
                                            }}
                                            onChange={handleDatos}
                                            variant='outlined'
                                            size='small'
                                            margin='dense'
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </React.Fragment>
                    }
                    {
                        (isOnuBridge || DatosD.isFree) &&
                        <React.Fragment>
                            <Grid item xl={4} lg={4} md={6} sm={6} xs={12} >
                                <Autocomplete
                                    id='Router'                                            
                                    options={onlyRouters}
                                    value={DatosD.Router || ''}
                                    onChange={handleRouters}
                                    renderInput={(params) => <TextField {...params} InputProps={{...params.InputProps, startAdornment: <RouterIcon/>,}} margin='dense' fullWidth label="Router" variant="outlined" required size='small'/>}
                                />
                            </Grid>
                            <Grid item xl={4} lg={4} md={6} sm={6} xs={12} >
                                <Autocomplete
                                    id='MacRouter'                                            
                                    options={macsRouters}
                                    inputValue={DatosD.MacRouter || ''}
                                    onInputChange={handleSelectMacRouter}
                                    getOptionLabel={(option) => option.Mac}
                                    renderOption={(option) => (
                                        <span style={{color: option.Status === 'Disponible' ? 'green' : option.Status === 'No Disponible' ? 'red' : 'orange'}}>{option.Mac}</span>
                                    )}
                                    renderInput={(params) => <TextField {...params} InputProps={{...params.InputProps, startAdornment: <RouterIcon/>,}} margin='dense' fullWidth label="Mac Router" variant="outlined" required size='small'/>}
                                />
                            </Grid>                            
                        </React.Fragment>
                    }     
                    <Grid item lg={2} md={6} sm={6} xs={12} >
                        <TextField 
                            id='UserMk'
                            fullWidth
                            label='UserLogin'
                            value={DatosD.UserMk || ''}
                            onChange={handleDatos}
                            variant='outlined'
                            size='small'
                            margin='dense'
                        />
                    </Grid>
                    <Grid item lg={3} md={6} sm={6} xs={12} >
                        <TextField 
                            id='PassMk'
                            fullWidth
                            label='PassLogin'
                            value={DatosD.PassMk || ''}
                            onChange={handleDatos}
                            variant='outlined'
                            margin='dense'
                            size='small'
                        />
                    </Grid>    
                           
                    <Grid item lg={3} md={6} sm={6} xs={12} > 
                        <TextField 
                            id='Instalacion'
                            fullWidth
                            label='Instalacion'
                            value={DatosD.Instalacion || ''}
                            InputProps={{
                                startAdornment:<DnsIcon/>
                            }}
                            onChange={handleDatosInstalacion}
                            variant='outlined'
                            size='small'
                            margin='dense'
                            type='date'
                        />                     
                    </Grid>
                    <Grid item lg={3} md={6} sm={6} xs={12} > 
                        <TextField 
                            id='HoraInstalacion'
                            fullWidth
                            label='HoraInstalacion'
                            value={DatosD.HoraInstalacion || ''}
                            InputProps={{
                                startAdornment:<DnsIcon/>
                            }}
                            onChange={handleDatos}
                            variant='outlined'
                            size='small'
                            margin='dense'
                            type='time'
                        />                     
                    </Grid>
                    <Grid item lg={1} md={6} sm={6} xs={12} >
                        <TooltipAntd title="EN MESES" color='blue'>
                            <TextField 
                                id='TiempoPermanencia'
                                fullWidth
                                label='Permanencia'
                                value={DatosD.TiempoPermanencia || ''}
                                onChange={handleDatos}
                                variant='outlined'
                                margin='dense'
                                size='small'
                                type='number'
                                placeholder='Meses'
                            />
                        </TooltipAntd>
                    </Grid>    
                    <Grid item lg={2} md={6} sm={6} xs={12} >
                        <TextField 
                            id='ValorInstalacion'
                            fullWidth
                            label='ValorInstalacion'
                            value={DatosD.ValorInstalacion}
                            InputProps={{
                                startAdornment:<MonetizationOnIcon/>
                            }}
                            onChange={handleDatos}
                            variant='outlined'
                            size='small'
                            margin='dense'
                            type='Number'
                        />    
                    </Grid>
                    <Grid item lg={2} md={6} sm={6} xs={12} >
                        <TextField 
                            id='ValorInstalacionCompleta'
                            fullWidth
                            label='Instalacion Completa'
                            value={DatosD.ValorInstalacionCompleta}
                            InputProps={{
                                startAdornment:<MonetizationOnIcon/>
                            }}
                            onChange={handleDatos}
                            variant='outlined'
                            size='small'
                            margin='dense'
                            type='Number'
                        />    
                    </Grid>
                    <Grid item lg={2} md={6} sm={6} xs={12} > 
                        <TextField 
                            id='DiaNotificacion'
                            fullWidth
                            label='Dia Notificacion'
                            InputProps={{startAdornment:<DnsIcon/>}}
                            value={DatosD.DiaNotificacion || ''}
                            onChange={handleDatos}
                            variant='outlined'
                            size='small'
                            margin='dense'
                            type='number'
                        />                     
                    </Grid>
                    <Grid item lg={2} md={6} sm={6} xs={12} > 
                        <TextField 
                            id='DiasCorte'
                            fullWidth
                            label='Dias Corte'
                            InputProps={{ startAdornment:<DnsIcon/>  }}
                            value={DatosD.DiasCorte || ''}
                            onChange={handleDatos}
                            variant='outlined'
                            size='small'
                            margin='dense'
                            type='number'
                        />                     
                    </Grid>
                    <Grid item lg={2} md={6} sm={6} xs={12} >
                        <TextField 
                            id='NameWifi'
                            fullWidth
                            label='NameWifi'
                            value={DatosD.NameWifi || ''}
                            onChange={handleDatos}
                            variant='outlined'
                            size='small'
                            margin='dense'
                        />
                    </Grid>
                    <Grid item lg={2} md={6} sm={6} xs={12} >
                        <TextField 
                            id='PassWifi'
                            fullWidth
                            label='PassWifi'
                            value={DatosD.PassWifi || ''}
                            onChange={handleDatos}
                            variant='outlined'
                            size='small'
                            margin='dense'
                        />
                    </Grid>
                    <Grid item lg={4} md={6} sm={6} xs={12} >
                        <TextField 
                            id='Comentario'
                            fullWidth
                            label='Comentario'
                            value={DatosD.Comentario || ''}
                            onChange={handleDatos}
                            variant='outlined'
                            size='small'
                            margin='dense'
                        />
                    </Grid>
                    
                    <Grid item md={2} xs={6} style={{display:'flex', justifyContent:'center', alignItems:'center'}} >
                        <TooltipAntd title="TIPO DE SERVICIO" color='BLUE' >
                            <SwitchAntd checkedChildren="PREPAGO" unCheckedChildren="POSTPAGO" checked={DatosD.TipoPagoBoolean} onChange={handleTipoPago} />
                        </TooltipAntd>  
                    </Grid>
                    <Grid item md={2} xs={6} style={{display:'flex', justifyContent:'center', alignItems:'center'}} >
                        <TooltipAntd title="TIPO DE CORTE" color='BLUE' >
                            <SwitchAntd checkedChildren="AUTOMATICO" unCheckedChildren="MANUAL" checked={DatosD.CorteAutomatico} onChange={handleCorteAutomatico} />
                        </TooltipAntd>  
                    </Grid>
                    <Grid item lg={4} md={6} sm={6} xs={12} style={{alignSelf:'center', paddingTop:7, display:'flex', flexDirection:'row'}}>
                        <Card variant='outlined' style={{height:50, display:'flex', flexDirection:'row', alignItems:'center',justifyContent:'center', margin:'dense', alignSelf:'center', width:'100%'}} >
                            <CardContent style={{alignSelf:'center', paddingTop:25}}>
                                INST.:
                                Completo
                                <Switch
                                    checked={DatosD.StatusIns}
                                    onChange={handleStatusIns}
                                    color="primary"
                                    name="checkedB"
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                />
                                Parcial
                                {
                                    DatosD.StatusIns && 
                                    <React.Fragment>
                                        {
                                            isNewService && 
                                            <TextField 
                                                id='AvanceInstalacion'
                                                label='Avance'
                                                value={getAvance}
                                                onChange={({target})=>setAvance(target.value)}
                                                //variant='outlined'
                                                size='small'
                                                margin='dense'
                                                type='Number'
                                                style={{marginLeft:25, marginTop:-8, width:100}}
                                            />  
                                        }
                                    </React.Fragment>
                                }
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item sm={6} xs={12} >
                        <Paper style={{minHeight:300}} elevation={3}>
                        < div
                            ref={ mapDiv }
                            style={{width:'100%', height:'100%', minHeight:300}} 
                        />
                        </Paper>
                    </Grid>             
                </Grid>
            </Paper>
        </Grid>
    )
});

export default ElementServiciosFibra;